export const espnteams26 = [
  {
    "id": 2005,
    "school": "Air Force",
    "mascot": "Falcons",
    "abbreviation": "AF",
    "alternateNames": [
      "AF",
      "Air Force"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#003594",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2005.png",
      "https://cdn.collegefootballdata.com/logos/256/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2005.png",
      "https://cdn.collegefootballdata.com/logos/128/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2005.png",
      "https://cdn.collegefootballdata.com/logos/96/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2005.png",
      "https://cdn.collegefootballdata.com/logos/64/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2005.png",
      "https://cdn.collegefootballdata.com/logos/48/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2005.png",
      "https://cdn.collegefootballdata.com/logos/32/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2005.png",
      "https://cdn.collegefootballdata.com/logos/16/2005.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2005.png"
    ],
    "twitter": "@AF_Football",
    "location": {
      "id": 3713,
      "name": "Falcon Stadium",
      "city": "Colorado Springs",
      "state": "CO",
      "zip": "80840",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 38.9969701,
      "longitude": -104.8436165,
      "elevation": "2024.875732",
      "capacity": 46692,
      "constructionYear": 1962,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2006,
    "school": "Akron",
    "mascot": "Zips",
    "abbreviation": "AKR",
    "alternateNames": [
      "AKR",
      "Akron"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#041e42",
    "alternateColor": "#a89968",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2006.png",
      "https://cdn.collegefootballdata.com/logos/256/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2006.png",
      "https://cdn.collegefootballdata.com/logos/128/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2006.png",
      "https://cdn.collegefootballdata.com/logos/96/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2006.png",
      "https://cdn.collegefootballdata.com/logos/64/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2006.png",
      "https://cdn.collegefootballdata.com/logos/48/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2006.png",
      "https://cdn.collegefootballdata.com/logos/32/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2006.png",
      "https://cdn.collegefootballdata.com/logos/16/2006.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2006.png"
    ],
    "twitter": "@ZipsFB",
    "location": {
      "id": 3768,
      "name": "InfoCision Stadium",
      "city": "Akron",
      "state": "OH",
      "zip": "44399",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.0725534,
      "longitude": -81.5083408,
      "elevation": "321.2875061",
      "capacity": 30000,
      "constructionYear": 2009,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 333,
    "school": "Alabama",
    "mascot": "Crimson Tide",
    "abbreviation": "ALA",
    "alternateNames": [
      "ALA",
      "Alabama"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#9e1b32",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/333.png",
      "https://cdn.collegefootballdata.com/logos/256/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/333.png",
      "https://cdn.collegefootballdata.com/logos/128/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/333.png",
      "https://cdn.collegefootballdata.com/logos/96/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/333.png",
      "https://cdn.collegefootballdata.com/logos/64/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/333.png",
      "https://cdn.collegefootballdata.com/logos/48/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/333.png",
      "https://cdn.collegefootballdata.com/logos/32/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/333.png",
      "https://cdn.collegefootballdata.com/logos/16/333.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/333.png"
    ],
    "twitter": "@AlabamaFTBL",
    "location": {
      "id": 3657,
      "name": "Bryant-Denny Stadium",
      "city": "Tuscaloosa",
      "state": "AL",
      "zip": "35487",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.2082752,
      "longitude": -87.5503836,
      "elevation": "70.05136108",
      "capacity": 101821,
      "constructionYear": 1929,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2026,
    "school": "App State",
    "mascot": "Mountaineers",
    "abbreviation": "APP",
    "alternateNames": [
      "Appalachian State",
      "APP",
      "App State"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#ffcd00",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2026.png",
      "https://cdn.collegefootballdata.com/logos/256/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2026.png",
      "https://cdn.collegefootballdata.com/logos/128/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2026.png",
      "https://cdn.collegefootballdata.com/logos/96/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2026.png",
      "https://cdn.collegefootballdata.com/logos/64/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2026.png",
      "https://cdn.collegefootballdata.com/logos/48/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2026.png",
      "https://cdn.collegefootballdata.com/logos/32/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2026.png",
      "https://cdn.collegefootballdata.com/logos/16/2026.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2026.png"
    ],
    "twitter": "@AppState_FB",
    "location": {
      "id": 3792,
      "name": "Kidd Brewer Stadium",
      "city": "Boone",
      "state": "NC",
      "zip": "28608",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 36.2114267,
      "longitude": -81.6854278,
      "elevation": "991.3414307",
      "capacity": 30000,
      "constructionYear": 1962,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 12,
    "school": "Arizona",
    "mascot": "Wildcats",
    "abbreviation": "ARIZ",
    "alternateNames": [
      "ARIZ",
      "Arizona"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#cc0033",
    "alternateColor": "#003366",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/12.png",
      "https://cdn.collegefootballdata.com/logos/256/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/12.png",
      "https://cdn.collegefootballdata.com/logos/128/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/12.png",
      "https://cdn.collegefootballdata.com/logos/96/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/12.png",
      "https://cdn.collegefootballdata.com/logos/64/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/12.png",
      "https://cdn.collegefootballdata.com/logos/48/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/12.png",
      "https://cdn.collegefootballdata.com/logos/32/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/12.png",
      "https://cdn.collegefootballdata.com/logos/16/12.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/12.png"
    ],
    "twitter": "@ArizonaFBall",
    "location": {
      "id": 3619,
      "name": "Arizona Stadium",
      "city": "Tucson",
      "state": "AZ",
      "zip": "85721",
      "countryCode": "US",
      "timezone": "America/Phoenix",
      "latitude": 32.2288054,
      "longitude": -110.9488677,
      "elevation": "742.1530151",
      "capacity": 50782,
      "constructionYear": 1928,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 9,
    "school": "Arizona State",
    "mascot": "Sun Devils",
    "abbreviation": "ASU",
    "alternateNames": [
      "ASU",
      "Arizona St"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#ffc627",
    "alternateColor": "#8c1d40",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/9.png",
      "https://cdn.collegefootballdata.com/logos/256/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/9.png",
      "https://cdn.collegefootballdata.com/logos/128/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/9.png",
      "https://cdn.collegefootballdata.com/logos/96/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/9.png",
      "https://cdn.collegefootballdata.com/logos/64/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/9.png",
      "https://cdn.collegefootballdata.com/logos/48/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/9.png",
      "https://cdn.collegefootballdata.com/logos/32/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/9.png",
      "https://cdn.collegefootballdata.com/logos/16/9.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/9.png"
    ],
    "twitter": "@ASUFootball",
    "location": {
      "id": 3947,
      "name": "Mountain America Stadium",
      "city": "Tempe",
      "state": "AZ",
      "zip": "85287",
      "countryCode": "US",
      "timezone": "America/Phoenix",
      "latitude": 33.4264471,
      "longitude": -111.9325005,
      "elevation": "360.1569519",
      "capacity": 65870,
      "constructionYear": 1958,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 8,
    "school": "Arkansas",
    "mascot": "Razorbacks",
    "abbreviation": "ARK",
    "alternateNames": [
      "ARK",
      "Arkansas"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#a32136",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/8.png",
      "https://cdn.collegefootballdata.com/logos/256/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/8.png",
      "https://cdn.collegefootballdata.com/logos/128/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/8.png",
      "https://cdn.collegefootballdata.com/logos/96/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/8.png",
      "https://cdn.collegefootballdata.com/logos/64/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/8.png",
      "https://cdn.collegefootballdata.com/logos/48/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/8.png",
      "https://cdn.collegefootballdata.com/logos/32/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/8.png",
      "https://cdn.collegefootballdata.com/logos/16/8.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/8.png"
    ],
    "twitter": "@RazorbackFB",
    "location": {
      "id": 3887,
      "name": "Razorback Stadium",
      "city": "Fayetteville",
      "state": "AR",
      "zip": "72702",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 36.0680662,
      "longitude": -94.1789534,
      "elevation": "403.7972412",
      "capacity": 80000,
      "constructionYear": 1938,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2032,
    "school": "Arkansas State",
    "mascot": "Red Wolves",
    "abbreviation": "ARST",
    "alternateNames": [
      "ARST",
      "Arkansas St"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#cc092f",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2032.png",
      "https://cdn.collegefootballdata.com/logos/256/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2032.png",
      "https://cdn.collegefootballdata.com/logos/128/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2032.png",
      "https://cdn.collegefootballdata.com/logos/96/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2032.png",
      "https://cdn.collegefootballdata.com/logos/64/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2032.png",
      "https://cdn.collegefootballdata.com/logos/48/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2032.png",
      "https://cdn.collegefootballdata.com/logos/32/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2032.png",
      "https://cdn.collegefootballdata.com/logos/16/2032.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2032.png"
    ],
    "twitter": "@AStateFB",
    "location": {
      "id": 3625,
      "name": "Centennial Bank Stadium",
      "city": "Jonesboro",
      "state": "AR",
      "zip": "72404",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 35.8488977,
      "longitude": -90.6677436,
      "elevation": "89.52690887",
      "capacity": 30382,
      "constructionYear": 1974,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 349,
    "school": "Army",
    "mascot": "Black Knights",
    "abbreviation": "ARMY",
    "alternateNames": [
      "ARMY",
      "Army"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#d3bc8d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/349.png",
      "https://cdn.collegefootballdata.com/logos/256/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/349.png",
      "https://cdn.collegefootballdata.com/logos/128/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/349.png",
      "https://cdn.collegefootballdata.com/logos/96/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/349.png",
      "https://cdn.collegefootballdata.com/logos/64/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/349.png",
      "https://cdn.collegefootballdata.com/logos/48/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/349.png",
      "https://cdn.collegefootballdata.com/logos/32/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/349.png",
      "https://cdn.collegefootballdata.com/logos/16/349.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/349.png"
    ],
    "twitter": "@ArmyWP_Football",
    "location": {
      "id": 3841,
      "name": "Michie Stadium",
      "city": "West Point",
      "state": "NY",
      "zip": "10996",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.3874924,
      "longitude": -73.9640891,
      "elevation": "99.21277618",
      "capacity": 38000,
      "constructionYear": 1924,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2,
    "school": "Auburn",
    "mascot": "Tigers",
    "abbreviation": "AUB",
    "alternateNames": [
      "AUB",
      "Auburn"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#0c2340",
    "alternateColor": "#f26522",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2.png",
      "https://cdn.collegefootballdata.com/logos/256/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2.png",
      "https://cdn.collegefootballdata.com/logos/128/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2.png",
      "https://cdn.collegefootballdata.com/logos/96/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2.png",
      "https://cdn.collegefootballdata.com/logos/64/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2.png",
      "https://cdn.collegefootballdata.com/logos/48/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2.png",
      "https://cdn.collegefootballdata.com/logos/32/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2.png",
      "https://cdn.collegefootballdata.com/logos/16/2.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2.png"
    ],
    "twitter": "@AuburnFootball",
    "location": {
      "id": 3785,
      "name": "Jordan-Hare Stadium",
      "city": "Auburn",
      "state": "AL",
      "zip": "36849",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 32.6025532,
      "longitude": -85.4897479,
      "elevation": "201.1737976",
      "capacity": 87451,
      "constructionYear": 1939,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2050,
    "school": "Ball State",
    "mascot": "Cardinals",
    "abbreviation": "BALL",
    "alternateNames": [
      "BALL",
      "Ball State"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#ba0c2f",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2050.png",
      "https://cdn.collegefootballdata.com/logos/256/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2050.png",
      "https://cdn.collegefootballdata.com/logos/128/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2050.png",
      "https://cdn.collegefootballdata.com/logos/96/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2050.png",
      "https://cdn.collegefootballdata.com/logos/64/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2050.png",
      "https://cdn.collegefootballdata.com/logos/48/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2050.png",
      "https://cdn.collegefootballdata.com/logos/32/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2050.png",
      "https://cdn.collegefootballdata.com/logos/16/2050.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2050.png"
    ],
    "twitter": "@BallStateFB",
    "location": {
      "id": 3919,
      "name": "Scheumann Stadium",
      "city": "Muncie",
      "state": "IN",
      "zip": "47306",
      "countryCode": "US",
      "timezone": "America/Indiana/Indianapolis",
      "latitude": 40.2159422,
      "longitude": -85.4161148,
      "elevation": "285.481781",
      "capacity": 22500,
      "constructionYear": 1967,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 239,
    "school": "Baylor",
    "mascot": "Bears",
    "abbreviation": "BAY",
    "alternateNames": [
      "BAY",
      "Baylor"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#154734",
    "alternateColor": "#ffb81c",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/239.png",
      "https://cdn.collegefootballdata.com/logos/256/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/239.png",
      "https://cdn.collegefootballdata.com/logos/128/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/239.png",
      "https://cdn.collegefootballdata.com/logos/96/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/239.png",
      "https://cdn.collegefootballdata.com/logos/64/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/239.png",
      "https://cdn.collegefootballdata.com/logos/48/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/239.png",
      "https://cdn.collegefootballdata.com/logos/32/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/239.png",
      "https://cdn.collegefootballdata.com/logos/16/239.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/239.png"
    ],
    "twitter": "@BUFootball",
    "location": {
      "id": 4727,
      "name": "McLane Stadium",
      "city": "Waco",
      "state": "TX",
      "zip": "76704",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 31.5582015,
      "longitude": -97.1156702,
      "elevation": "117.0538101",
      "capacity": 45140,
      "constructionYear": 2014,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 68,
    "school": "Boise State",
    "mascot": "Broncos",
    "abbreviation": "BOIS",
    "alternateNames": [
      "BOIS",
      "Boise St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#0033a0",
    "alternateColor": "#d64309",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/68.png",
      "https://cdn.collegefootballdata.com/logos/256/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/68.png",
      "https://cdn.collegefootballdata.com/logos/128/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/68.png",
      "https://cdn.collegefootballdata.com/logos/96/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/68.png",
      "https://cdn.collegefootballdata.com/logos/64/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/68.png",
      "https://cdn.collegefootballdata.com/logos/48/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/68.png",
      "https://cdn.collegefootballdata.com/logos/32/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/68.png",
      "https://cdn.collegefootballdata.com/logos/16/68.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/68.png"
    ],
    "twitter": "@BroncoSportsFB",
    "location": {
      "id": 3653,
      "name": "Albertsons Stadium",
      "city": "Boise",
      "state": "ID",
      "zip": "83725",
      "countryCode": "US",
      "timezone": "America/Boise",
      "latitude": 43.6028839,
      "longitude": -116.1958882,
      "elevation": "823.2221069",
      "capacity": 36387,
      "constructionYear": 1970,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 103,
    "school": "Boston College",
    "mascot": "Eagles",
    "abbreviation": "BC",
    "alternateNames": [
      "BC",
      "Boston College"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#8c2232",
    "alternateColor": "#dbcca6",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/103.png",
      "https://cdn.collegefootballdata.com/logos/256/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/103.png",
      "https://cdn.collegefootballdata.com/logos/128/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/103.png",
      "https://cdn.collegefootballdata.com/logos/96/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/103.png",
      "https://cdn.collegefootballdata.com/logos/64/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/103.png",
      "https://cdn.collegefootballdata.com/logos/48/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/103.png",
      "https://cdn.collegefootballdata.com/logos/32/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/103.png",
      "https://cdn.collegefootballdata.com/logos/16/103.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/103.png"
    ],
    "twitter": "@BCFootball",
    "location": {
      "id": 3615,
      "name": "Alumni Stadium (Chestnut Hill, MA)",
      "city": "Chestnut Hill",
      "state": "MA",
      "zip": "2467 ",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 42.335104,
      "longitude": -71.1664413,
      "elevation": "39.82634354",
      "capacity": 44500,
      "constructionYear": 1957,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 189,
    "school": "Bowling Green",
    "mascot": "Falcons",
    "abbreviation": "BGSU",
    "alternateNames": [
      "Bowling Green State",
      "BGSU",
      "Bowling Green"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#fd5000",
    "alternateColor": "#4f2c1d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/189.png",
      "https://cdn.collegefootballdata.com/logos/256/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/189.png",
      "https://cdn.collegefootballdata.com/logos/128/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/189.png",
      "https://cdn.collegefootballdata.com/logos/96/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/189.png",
      "https://cdn.collegefootballdata.com/logos/64/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/189.png",
      "https://cdn.collegefootballdata.com/logos/48/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/189.png",
      "https://cdn.collegefootballdata.com/logos/32/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/189.png",
      "https://cdn.collegefootballdata.com/logos/16/189.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/189.png"
    ],
    "twitter": "@BG_Football",
    "location": {
      "id": 3700,
      "name": "Doyt L. Perry Stadium",
      "city": "Bowling Green",
      "state": "OH",
      "zip": "43403",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.3780114,
      "longitude": -83.6225,
      "elevation": "205.9057465",
      "capacity": 24000,
      "constructionYear": 1966,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2084,
    "school": "Buffalo",
    "mascot": "Bulls",
    "abbreviation": "BUF",
    "alternateNames": [
      "BUF",
      "Buffalo"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#005bbb",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2084.png",
      "https://cdn.collegefootballdata.com/logos/256/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2084.png",
      "https://cdn.collegefootballdata.com/logos/128/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2084.png",
      "https://cdn.collegefootballdata.com/logos/96/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2084.png",
      "https://cdn.collegefootballdata.com/logos/64/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2084.png",
      "https://cdn.collegefootballdata.com/logos/48/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2084.png",
      "https://cdn.collegefootballdata.com/logos/32/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2084.png",
      "https://cdn.collegefootballdata.com/logos/16/2084.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2084.png"
    ],
    "twitter": "@UBFootball",
    "location": {
      "id": 3965,
      "name": "UB Stadium",
      "city": "Amherst",
      "state": "NY",
      "zip": "14260",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 42.9991334,
      "longitude": -78.7775113,
      "elevation": "181.5759735",
      "capacity": 30270,
      "constructionYear": 1993,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 252,
    "school": "BYU",
    "mascot": "Cougars",
    "abbreviation": "BYU",
    "alternateNames": [
      "Brigham Young",
      "BYU",
      "BYU"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#003da5",
    "alternateColor": "#002e5d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/252.png",
      "https://cdn.collegefootballdata.com/logos/256/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/252.png",
      "https://cdn.collegefootballdata.com/logos/128/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/252.png",
      "https://cdn.collegefootballdata.com/logos/96/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/252.png",
      "https://cdn.collegefootballdata.com/logos/64/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/252.png",
      "https://cdn.collegefootballdata.com/logos/48/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/252.png",
      "https://cdn.collegefootballdata.com/logos/32/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/252.png",
      "https://cdn.collegefootballdata.com/logos/16/252.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/252.png"
    ],
    "twitter": "@BYUFootball",
    "location": {
      "id": 3801,
      "name": "LaVell Edwards Stadium",
      "city": "Provo",
      "state": "UT",
      "zip": "84602",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 40.2575347,
      "longitude": -111.6545247,
      "elevation": "1412.097046",
      "capacity": 63470,
      "constructionYear": 1964,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 25,
    "school": "California",
    "mascot": "Golden Bears",
    "abbreviation": "CAL",
    "alternateNames": [
      "CAL",
      "California"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#041e42",
    "alternateColor": "#ffc72c",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/25.png",
      "https://cdn.collegefootballdata.com/logos/256/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/25.png",
      "https://cdn.collegefootballdata.com/logos/128/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/25.png",
      "https://cdn.collegefootballdata.com/logos/96/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/25.png",
      "https://cdn.collegefootballdata.com/logos/64/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/25.png",
      "https://cdn.collegefootballdata.com/logos/48/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/25.png",
      "https://cdn.collegefootballdata.com/logos/32/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/25.png",
      "https://cdn.collegefootballdata.com/logos/16/25.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/25.png"
    ],
    "twitter": "@CalFootball",
    "location": {
      "id": 3831,
      "name": "California Memorial Stadium",
      "city": "Berkeley",
      "state": "CA",
      "zip": "94720",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 37.8710434,
      "longitude": -122.2507729,
      "elevation": "125.3108063",
      "capacity": 62467,
      "constructionYear": 1923,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2117,
    "school": "Central Michigan",
    "mascot": "Chippewas",
    "abbreviation": "CMU",
    "alternateNames": [
      "CMU",
      "C Michigan"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#6a0032",
    "alternateColor": "#ffc82e",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2117.png",
      "https://cdn.collegefootballdata.com/logos/256/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2117.png",
      "https://cdn.collegefootballdata.com/logos/128/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2117.png",
      "https://cdn.collegefootballdata.com/logos/96/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2117.png",
      "https://cdn.collegefootballdata.com/logos/64/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2117.png",
      "https://cdn.collegefootballdata.com/logos/48/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2117.png",
      "https://cdn.collegefootballdata.com/logos/32/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2117.png",
      "https://cdn.collegefootballdata.com/logos/16/2117.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2117.png"
    ],
    "twitter": "@CMU_Football",
    "location": {
      "id": 3786,
      "name": "Kelly/Shorts Stadium",
      "city": "Mount Pleasant",
      "state": "MI",
      "zip": "48859",
      "countryCode": "US",
      "timezone": "America/Detroit",
      "latitude": 43.5777313,
      "longitude": -84.7709904,
      "elevation": "240.9007721",
      "capacity": 30255,
      "constructionYear": 1972,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2429,
    "school": "Charlotte",
    "mascot": "49ers",
    "abbreviation": "CLT",
    "alternateNames": [
      "CLT",
      "Charlotte"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#005035",
    "alternateColor": "#a49665",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2429.png",
      "https://cdn.collegefootballdata.com/logos/256/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2429.png",
      "https://cdn.collegefootballdata.com/logos/128/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2429.png",
      "https://cdn.collegefootballdata.com/logos/96/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2429.png",
      "https://cdn.collegefootballdata.com/logos/64/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2429.png",
      "https://cdn.collegefootballdata.com/logos/48/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2429.png",
      "https://cdn.collegefootballdata.com/logos/32/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2429.png",
      "https://cdn.collegefootballdata.com/logos/16/2429.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2429.png"
    ],
    "twitter": "@CharlotteFTBL",
    "location": {
      "id": 4418,
      "name": "Jerry Richardson Stadium",
      "city": "Charlotte",
      "state": "NC",
      "zip": "28223",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.3105033,
      "longitude": -80.7401194,
      "elevation": "190.365509",
      "capacity": 15300,
      "constructionYear": 2013,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2132,
    "school": "Cincinnati",
    "mascot": "Bearcats",
    "abbreviation": "CIN",
    "alternateNames": [
      "CIN",
      "Cincinnati"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#e00122",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2132.png",
      "https://cdn.collegefootballdata.com/logos/256/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2132.png",
      "https://cdn.collegefootballdata.com/logos/128/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2132.png",
      "https://cdn.collegefootballdata.com/logos/96/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2132.png",
      "https://cdn.collegefootballdata.com/logos/64/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2132.png",
      "https://cdn.collegefootballdata.com/logos/48/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2132.png",
      "https://cdn.collegefootballdata.com/logos/32/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2132.png",
      "https://cdn.collegefootballdata.com/logos/16/2132.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2132.png"
    ],
    "twitter": "@GoBearcatsFB",
    "location": {
      "id": 3854,
      "name": "Nippert Stadium",
      "city": "Cincinnati",
      "state": "OH",
      "zip": "45221",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.1312495,
      "longitude": -84.5161913,
      "elevation": "230.0660553",
      "capacity": 40000,
      "constructionYear": 1915,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 228,
    "school": "Clemson",
    "mascot": "Tigers",
    "abbreviation": "CLEM",
    "alternateNames": [
      "CLEM",
      "Clemson"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#f56600",
    "alternateColor": "#522d80",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/228.png",
      "https://cdn.collegefootballdata.com/logos/256/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/228.png",
      "https://cdn.collegefootballdata.com/logos/128/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/228.png",
      "https://cdn.collegefootballdata.com/logos/96/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/228.png",
      "https://cdn.collegefootballdata.com/logos/64/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/228.png",
      "https://cdn.collegefootballdata.com/logos/48/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/228.png",
      "https://cdn.collegefootballdata.com/logos/32/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/228.png",
      "https://cdn.collegefootballdata.com/logos/16/228.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/228.png"
    ],
    "twitter": "@ClemsonFB",
    "location": {
      "id": 3836,
      "name": "Memorial Stadium (Clemson, SC)",
      "city": "Clemson",
      "state": "SC",
      "zip": "29634",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 34.6787737,
      "longitude": -82.8432428,
      "elevation": "205.6452179",
      "capacity": 81500,
      "constructionYear": 1942,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 324,
    "school": "Coastal Carolina",
    "mascot": "Chanticleers",
    "abbreviation": "CCU",
    "alternateNames": [
      "CCU",
      "Coastal"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#006f71",
    "alternateColor": "#a27752",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/324.png",
      "https://cdn.collegefootballdata.com/logos/256/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/324.png",
      "https://cdn.collegefootballdata.com/logos/128/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/324.png",
      "https://cdn.collegefootballdata.com/logos/96/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/324.png",
      "https://cdn.collegefootballdata.com/logos/64/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/324.png",
      "https://cdn.collegefootballdata.com/logos/48/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/324.png",
      "https://cdn.collegefootballdata.com/logos/32/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/324.png",
      "https://cdn.collegefootballdata.com/logos/16/324.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/324.png"
    ],
    "twitter": "@CoastalFootball",
    "location": {
      "id": 3654,
      "name": "Brooks Stadium (SC)",
      "city": "Conway",
      "state": "SC",
      "zip": "29528",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 33.7928506,
      "longitude": -79.0166946,
      "elevation": "13.74894905",
      "capacity": 21000,
      "constructionYear": 2003,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 38,
    "school": "Colorado",
    "mascot": "Buffaloes",
    "abbreviation": "COLO",
    "alternateNames": [
      "COLO",
      "Colorado"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#cfb87c",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/38.png",
      "https://cdn.collegefootballdata.com/logos/256/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/38.png",
      "https://cdn.collegefootballdata.com/logos/128/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/38.png",
      "https://cdn.collegefootballdata.com/logos/96/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/38.png",
      "https://cdn.collegefootballdata.com/logos/64/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/38.png",
      "https://cdn.collegefootballdata.com/logos/48/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/38.png",
      "https://cdn.collegefootballdata.com/logos/32/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/38.png",
      "https://cdn.collegefootballdata.com/logos/16/38.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/38.png"
    ],
    "twitter": "@CUBuffsFootball",
    "location": {
      "id": 3726,
      "name": "Folsom Field",
      "city": "Boulder",
      "state": "CO",
      "zip": "80309",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 40.0094746,
      "longitude": -105.266905,
      "elevation": "1634.041138",
      "capacity": 50183,
      "constructionYear": 1924,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 36,
    "school": "Colorado State",
    "mascot": "Rams",
    "abbreviation": "CSU",
    "alternateNames": [
      "CSU",
      "Colorado St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#1e4d2b",
    "alternateColor": "#c8c372",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/36.png",
      "https://cdn.collegefootballdata.com/logos/256/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/36.png",
      "https://cdn.collegefootballdata.com/logos/128/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/36.png",
      "https://cdn.collegefootballdata.com/logos/96/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/36.png",
      "https://cdn.collegefootballdata.com/logos/64/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/36.png",
      "https://cdn.collegefootballdata.com/logos/48/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/36.png",
      "https://cdn.collegefootballdata.com/logos/32/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/36.png",
      "https://cdn.collegefootballdata.com/logos/16/36.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/36.png"
    ],
    "twitter": "@CSUFootball",
    "location": {
      "id": 5388,
      "name": "Canvas Stadium",
      "city": "Fort Collins",
      "state": "CO",
      "zip": "80521",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 40.570015,
      "longitude": -105.088435,
      "elevation": "1528.4",
      "capacity": 36500,
      "constructionYear": 2017,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 48,
    "school": "Delaware",
    "mascot": "Blue Hens",
    "abbreviation": "DEL",
    "alternateNames": [
      "DEL",
      "Delaware"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#00539f",
    "alternateColor": "#ffd200",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/48.png",
      "https://cdn.collegefootballdata.com/logos/256/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/48.png",
      "https://cdn.collegefootballdata.com/logos/128/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/48.png",
      "https://cdn.collegefootballdata.com/logos/96/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/48.png",
      "https://cdn.collegefootballdata.com/logos/64/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/48.png",
      "https://cdn.collegefootballdata.com/logos/48/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/48.png",
      "https://cdn.collegefootballdata.com/logos/32/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/48.png",
      "https://cdn.collegefootballdata.com/logos/16/48.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/48.png"
    ],
    "twitter": "@DelawareFB",
    "location": {
      "id": 3695,
      "name": "Delaware Stadium",
      "city": "Newark",
      "state": "DE",
      "zip": "19713",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.6617428,
      "longitude": -75.7488224,
      "elevation": "28.74350357",
      "capacity": 22000,
      "constructionYear": 1952,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 150,
    "school": "Duke",
    "mascot": "Blue Devils",
    "abbreviation": "DUKE",
    "alternateNames": [
      "DUKE",
      "Duke"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#00539b",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/150.png",
      "https://cdn.collegefootballdata.com/logos/256/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/150.png",
      "https://cdn.collegefootballdata.com/logos/128/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/150.png",
      "https://cdn.collegefootballdata.com/logos/96/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/150.png",
      "https://cdn.collegefootballdata.com/logos/64/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/150.png",
      "https://cdn.collegefootballdata.com/logos/48/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/150.png",
      "https://cdn.collegefootballdata.com/logos/32/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/150.png",
      "https://cdn.collegefootballdata.com/logos/16/150.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/150.png"
    ],
    "twitter": "@DukeFootball",
    "location": {
      "id": 3982,
      "name": "Wallace Wade Stadium",
      "city": "Durham",
      "state": "NC",
      "zip": "27708",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.9953688,
      "longitude": -78.9417564,
      "elevation": "103.0028152",
      "capacity": 40004,
      "constructionYear": 1929,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 151,
    "school": "East Carolina",
    "mascot": "Pirates",
    "abbreviation": "ECU",
    "alternateNames": [
      "ECU",
      "East Carolina"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#592a8a",
    "alternateColor": "#fdc82f",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/151.png",
      "https://cdn.collegefootballdata.com/logos/256/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/151.png",
      "https://cdn.collegefootballdata.com/logos/128/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/151.png",
      "https://cdn.collegefootballdata.com/logos/96/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/151.png",
      "https://cdn.collegefootballdata.com/logos/64/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/151.png",
      "https://cdn.collegefootballdata.com/logos/48/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/151.png",
      "https://cdn.collegefootballdata.com/logos/32/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/151.png",
      "https://cdn.collegefootballdata.com/logos/16/151.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/151.png"
    ],
    "twitter": "@ECUPiratesFB",
    "location": {
      "id": 3699,
      "name": "Dowdy-Ficklen Stadium",
      "city": "Greenville",
      "state": "NC",
      "zip": "27858",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.5968486,
      "longitude": -77.364564,
      "elevation": "19.0564537",
      "capacity": 50000,
      "constructionYear": 1963,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2199,
    "school": "Eastern Michigan",
    "mascot": "Eagles",
    "abbreviation": "EMU",
    "alternateNames": [
      "EMU",
      "E Michigan"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#046a38",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2199.png",
      "https://cdn.collegefootballdata.com/logos/256/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2199.png",
      "https://cdn.collegefootballdata.com/logos/128/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2199.png",
      "https://cdn.collegefootballdata.com/logos/96/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2199.png",
      "https://cdn.collegefootballdata.com/logos/64/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2199.png",
      "https://cdn.collegefootballdata.com/logos/48/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2199.png",
      "https://cdn.collegefootballdata.com/logos/32/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2199.png",
      "https://cdn.collegefootballdata.com/logos/16/2199.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2199.png"
    ],
    "twitter": "@EMUFB",
    "location": {
      "id": 3912,
      "name": "Rynearson Stadium",
      "city": "Ypsilanti",
      "state": "MI",
      "zip": "48197",
      "countryCode": "US",
      "timezone": "America/Detroit",
      "latitude": 42.256126,
      "longitude": -83.647285,
      "elevation": "241.248764",
      "capacity": 30200,
      "constructionYear": 1969,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 57,
    "school": "Florida",
    "mascot": "Gators",
    "abbreviation": "FLA",
    "alternateNames": [
      "FLA",
      "Florida"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#0021a5",
    "alternateColor": "#fa4616",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/57.png",
      "https://cdn.collegefootballdata.com/logos/256/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/57.png",
      "https://cdn.collegefootballdata.com/logos/128/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/57.png",
      "https://cdn.collegefootballdata.com/logos/96/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/57.png",
      "https://cdn.collegefootballdata.com/logos/64/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/57.png",
      "https://cdn.collegefootballdata.com/logos/48/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/57.png",
      "https://cdn.collegefootballdata.com/logos/32/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/57.png",
      "https://cdn.collegefootballdata.com/logos/16/57.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/57.png"
    ],
    "twitter": "@GatorsFB",
    "location": {
      "id": 3634,
      "name": "Ben Hill Griffin Stadium",
      "city": "Gainesville",
      "state": "FL",
      "zip": "32653",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 29.6499357,
      "longitude": -82.3485788,
      "elevation": "44.97250748",
      "capacity": 88548,
      "constructionYear": 1930,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2226,
    "school": "Florida Atlantic",
    "mascot": "Owls",
    "abbreviation": "FAU",
    "alternateNames": [
      "FAU",
      "FAU"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#003366",
    "alternateColor": "#cc0000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2226.png",
      "https://cdn.collegefootballdata.com/logos/256/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2226.png",
      "https://cdn.collegefootballdata.com/logos/128/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2226.png",
      "https://cdn.collegefootballdata.com/logos/96/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2226.png",
      "https://cdn.collegefootballdata.com/logos/64/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2226.png",
      "https://cdn.collegefootballdata.com/logos/48/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2226.png",
      "https://cdn.collegefootballdata.com/logos/32/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2226.png",
      "https://cdn.collegefootballdata.com/logos/16/2226.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2226.png"
    ],
    "twitter": "@FAUFootball",
    "location": {
      "id": 3715,
      "name": "FAU Stadium",
      "city": "Boca Raton",
      "state": "FL",
      "zip": "33499",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 26.3763763,
      "longitude": -80.1015759,
      "elevation": "3.613628864",
      "capacity": 29419,
      "constructionYear": 2011,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2229,
    "school": "Florida International",
    "mascot": "Panthers",
    "abbreviation": "FIU",
    "alternateNames": [
      "Florida Intl",
      "FIU",
      "FIU"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#091f3f",
    "alternateColor": "#c3993f",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2229.png",
      "https://cdn.collegefootballdata.com/logos/256/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2229.png",
      "https://cdn.collegefootballdata.com/logos/128/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2229.png",
      "https://cdn.collegefootballdata.com/logos/96/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2229.png",
      "https://cdn.collegefootballdata.com/logos/64/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2229.png",
      "https://cdn.collegefootballdata.com/logos/48/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2229.png",
      "https://cdn.collegefootballdata.com/logos/32/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2229.png",
      "https://cdn.collegefootballdata.com/logos/16/2229.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2229.png"
    ],
    "twitter": "@FIUFootball",
    "location": {
      "id": 2031,
      "name": "Pitbull Stadium",
      "city": "Miami",
      "state": "FL",
      "zip": "33199",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 25.7525,
      "longitude": -80.37778,
      "elevation": "6",
      "capacity": 20000,
      "constructionYear": 1995,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 52,
    "school": "Florida State",
    "mascot": "Seminoles",
    "abbreviation": "FSU",
    "alternateNames": [
      "FSU",
      "Florida St"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#782f40",
    "alternateColor": "#ceb888",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/52.png",
      "https://cdn.collegefootballdata.com/logos/256/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/52.png",
      "https://cdn.collegefootballdata.com/logos/128/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/52.png",
      "https://cdn.collegefootballdata.com/logos/96/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/52.png",
      "https://cdn.collegefootballdata.com/logos/64/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/52.png",
      "https://cdn.collegefootballdata.com/logos/48/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/52.png",
      "https://cdn.collegefootballdata.com/logos/32/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/52.png",
      "https://cdn.collegefootballdata.com/logos/16/52.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/52.png"
    ],
    "twitter": "@FSUFootball",
    "location": {
      "id": 3697,
      "name": "Doak Campbell Stadium",
      "city": "Tallahassee",
      "state": "FL",
      "zip": "32306",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 30.4381692,
      "longitude": -84.3044032,
      "elevation": "19.55942535",
      "capacity": 67277,
      "constructionYear": 1950,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 278,
    "school": "Fresno State",
    "mascot": "Bulldogs",
    "abbreviation": "FRES",
    "alternateNames": [
      "FRES",
      "Fresno St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#c41230",
    "alternateColor": "#13284c",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/278.png",
      "https://cdn.collegefootballdata.com/logos/256/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/278.png",
      "https://cdn.collegefootballdata.com/logos/128/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/278.png",
      "https://cdn.collegefootballdata.com/logos/96/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/278.png",
      "https://cdn.collegefootballdata.com/logos/64/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/278.png",
      "https://cdn.collegefootballdata.com/logos/48/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/278.png",
      "https://cdn.collegefootballdata.com/logos/32/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/278.png",
      "https://cdn.collegefootballdata.com/logos/16/278.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/278.png"
    ],
    "twitter": "@FresnoStateFB",
    "location": {
      "id": 3660,
      "name": "Valley Children's Stadium",
      "city": "Fresno",
      "state": "CA",
      "zip": "93740",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 36.8143527,
      "longitude": -119.7580092,
      "elevation": "102.564064",
      "capacity": 41031,
      "constructionYear": 1980,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 61,
    "school": "Georgia",
    "mascot": "Bulldogs",
    "abbreviation": "UGA",
    "alternateNames": [
      "UGA",
      "Georgia"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#ba0c2f",
    "alternateColor": "#2c2a29",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/61.png",
      "https://cdn.collegefootballdata.com/logos/256/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/61.png",
      "https://cdn.collegefootballdata.com/logos/128/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/61.png",
      "https://cdn.collegefootballdata.com/logos/96/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/61.png",
      "https://cdn.collegefootballdata.com/logos/64/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/61.png",
      "https://cdn.collegefootballdata.com/logos/48/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/61.png",
      "https://cdn.collegefootballdata.com/logos/32/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/61.png",
      "https://cdn.collegefootballdata.com/logos/16/61.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/61.png"
    ],
    "twitter": "@GeorgiaFootball",
    "location": {
      "id": 3917,
      "name": "Sanford Stadium",
      "city": "Athens",
      "state": "GA",
      "zip": "30602",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 33.9498197,
      "longitude": -83.3733813,
      "elevation": "186.1120758",
      "capacity": 92746,
      "constructionYear": 1929,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 290,
    "school": "Georgia Southern",
    "mascot": "Eagles",
    "abbreviation": "GASO",
    "alternateNames": [
      "GASO",
      "GA Southern"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#041e42",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/290.png",
      "https://cdn.collegefootballdata.com/logos/256/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/290.png",
      "https://cdn.collegefootballdata.com/logos/128/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/290.png",
      "https://cdn.collegefootballdata.com/logos/96/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/290.png",
      "https://cdn.collegefootballdata.com/logos/64/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/290.png",
      "https://cdn.collegefootballdata.com/logos/48/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/290.png",
      "https://cdn.collegefootballdata.com/logos/32/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/290.png",
      "https://cdn.collegefootballdata.com/logos/16/290.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/290.png"
    ],
    "twitter": "@GSAthletics_FB",
    "location": {
      "id": 3608,
      "name": "Allen E. Paulson Stadium",
      "city": "Statesboro",
      "state": "GA",
      "zip": "30460",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 32.4122471,
      "longitude": -81.7849296,
      "elevation": "61.25376892",
      "capacity": 25000,
      "constructionYear": 1984,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2247,
    "school": "Georgia State",
    "mascot": "Panthers",
    "abbreviation": "GAST",
    "alternateNames": [
      "GAST",
      "Georgia St"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#0039a6",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2247.png",
      "https://cdn.collegefootballdata.com/logos/256/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2247.png",
      "https://cdn.collegefootballdata.com/logos/128/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2247.png",
      "https://cdn.collegefootballdata.com/logos/96/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2247.png",
      "https://cdn.collegefootballdata.com/logos/64/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2247.png",
      "https://cdn.collegefootballdata.com/logos/48/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2247.png",
      "https://cdn.collegefootballdata.com/logos/32/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2247.png",
      "https://cdn.collegefootballdata.com/logos/16/2247.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2247.png"
    ],
    "twitter": "@GeorgiaStateFB",
    "location": {
      "id": 4246,
      "name": "Center Parc Stadium",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30315",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 33.735267,
      "longitude": -84.389949,
      "elevation": "287",
      "capacity": 25000,
      "constructionYear": 2017,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 59,
    "school": "Georgia Tech",
    "mascot": "Yellow Jackets",
    "abbreviation": "GT",
    "alternateNames": [
      "GT",
      "Georgia Tech"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#b3a369",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/59.png",
      "https://cdn.collegefootballdata.com/logos/256/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/59.png",
      "https://cdn.collegefootballdata.com/logos/128/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/59.png",
      "https://cdn.collegefootballdata.com/logos/96/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/59.png",
      "https://cdn.collegefootballdata.com/logos/64/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/59.png",
      "https://cdn.collegefootballdata.com/logos/48/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/59.png",
      "https://cdn.collegefootballdata.com/logos/32/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/59.png",
      "https://cdn.collegefootballdata.com/logos/16/59.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/59.png"
    ],
    "twitter": "@GeorgiaTechFB",
    "location": {
      "id": 721,
      "name": "Bobby Dodd Stadium",
      "city": "Atlanta",
      "state": "GA",
      "zip": "30332",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 33.7724449,
      "longitude": -84.3928054,
      "elevation": "279.300415",
      "capacity": 55000,
      "constructionYear": 1913,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 62,
    "school": "Hawai'i",
    "mascot": "Rainbow Warriors",
    "abbreviation": "HAW",
    "alternateNames": [
      "HAW",
      "Hawai'i"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#024731",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/62.png",
      "https://cdn.collegefootballdata.com/logos/256/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/62.png",
      "https://cdn.collegefootballdata.com/logos/128/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/62.png",
      "https://cdn.collegefootballdata.com/logos/96/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/62.png",
      "https://cdn.collegefootballdata.com/logos/64/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/62.png",
      "https://cdn.collegefootballdata.com/logos/48/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/62.png",
      "https://cdn.collegefootballdata.com/logos/32/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/62.png",
      "https://cdn.collegefootballdata.com/logos/16/62.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/62.png"
    ],
    "twitter": "@HawaiiFootball",
    "location": {
      "id": 7220,
      "name": "Clarence T.C. Ching Athletics Complex",
      "city": "Honolulu",
      "state": "HI",
      "zip": "96822",
      "countryCode": "US",
      "timezone": "Pacific/Honolulu",
      "latitude": 21.294294,
      "longitude": -157.819338,
      "elevation": "20",
      "capacity": 15194,
      "constructionYear": 2015,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 248,
    "school": "Houston",
    "mascot": "Cougars",
    "abbreviation": "HOU",
    "alternateNames": [
      "HOU",
      "Houston"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#c8102e",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/248.png",
      "https://cdn.collegefootballdata.com/logos/256/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/248.png",
      "https://cdn.collegefootballdata.com/logos/128/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/248.png",
      "https://cdn.collegefootballdata.com/logos/96/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/248.png",
      "https://cdn.collegefootballdata.com/logos/64/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/248.png",
      "https://cdn.collegefootballdata.com/logos/48/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/248.png",
      "https://cdn.collegefootballdata.com/logos/32/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/248.png",
      "https://cdn.collegefootballdata.com/logos/16/248.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/248.png"
    ],
    "twitter": "@UHCougarFB",
    "location": {
      "id": 4728,
      "name": "TDECU Stadium",
      "city": "Houston",
      "state": "TX",
      "zip": "77004",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 29.7219885,
      "longitude": -95.3491623,
      "elevation": "9.57440567",
      "capacity": 40000,
      "constructionYear": 2014,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 356,
    "school": "Illinois",
    "mascot": "Fighting Illini",
    "abbreviation": "ILL",
    "alternateNames": [
      "ILL",
      "Illinois"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#ff5f05",
    "alternateColor": "#13294b",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/356.png",
      "https://cdn.collegefootballdata.com/logos/256/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/356.png",
      "https://cdn.collegefootballdata.com/logos/128/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/356.png",
      "https://cdn.collegefootballdata.com/logos/96/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/356.png",
      "https://cdn.collegefootballdata.com/logos/64/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/356.png",
      "https://cdn.collegefootballdata.com/logos/48/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/356.png",
      "https://cdn.collegefootballdata.com/logos/32/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/356.png",
      "https://cdn.collegefootballdata.com/logos/16/356.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/356.png"
    ],
    "twitter": "@IlliniFootball",
    "location": {
      "id": 3832,
      "name": "Memorial Stadium (Champaign, IL)",
      "city": "Champaign",
      "state": "IL",
      "zip": "61820",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 40.0993268,
      "longitude": -88.2359569,
      "elevation": "223.2471619",
      "capacity": 60670,
      "constructionYear": 1923,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 84,
    "school": "Indiana",
    "mascot": "Hoosiers",
    "abbreviation": "IU",
    "alternateNames": [
      "IU",
      "Indiana"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#990000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/84.png",
      "https://cdn.collegefootballdata.com/logos/256/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/84.png",
      "https://cdn.collegefootballdata.com/logos/128/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/84.png",
      "https://cdn.collegefootballdata.com/logos/96/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/84.png",
      "https://cdn.collegefootballdata.com/logos/64/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/84.png",
      "https://cdn.collegefootballdata.com/logos/48/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/84.png",
      "https://cdn.collegefootballdata.com/logos/32/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/84.png",
      "https://cdn.collegefootballdata.com/logos/16/84.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/84.png"
    ],
    "twitter": "@IndianaFootball",
    "location": {
      "id": 3830,
      "name": "Memorial Stadium (Bloomington, IN)",
      "city": "Bloomington",
      "state": "IN",
      "zip": "47408",
      "countryCode": "US",
      "timezone": "America/Indiana/Indianapolis",
      "latitude": 39.1808959,
      "longitude": -86.5256217,
      "elevation": "231.6500854",
      "capacity": 52656,
      "constructionYear": 1960,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2294,
    "school": "Iowa",
    "mascot": "Hawkeyes",
    "abbreviation": "IOWA",
    "alternateNames": [
      "IOWA",
      "Iowa"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#ffcd00",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2294.png",
      "https://cdn.collegefootballdata.com/logos/256/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2294.png",
      "https://cdn.collegefootballdata.com/logos/128/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2294.png",
      "https://cdn.collegefootballdata.com/logos/96/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2294.png",
      "https://cdn.collegefootballdata.com/logos/64/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2294.png",
      "https://cdn.collegefootballdata.com/logos/48/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2294.png",
      "https://cdn.collegefootballdata.com/logos/32/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2294.png",
      "https://cdn.collegefootballdata.com/logos/16/2294.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2294.png"
    ],
    "twitter": "@HawkeyeFootball",
    "location": {
      "id": 3793,
      "name": "Kinnick Stadium",
      "city": "Iowa City",
      "state": "IA",
      "zip": "52242",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 41.6586045,
      "longitude": -91.5510829,
      "elevation": "220.6357727",
      "capacity": 69250,
      "constructionYear": 1929,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 66,
    "school": "Iowa State",
    "mascot": "Cyclones",
    "abbreviation": "ISU",
    "alternateNames": [
      "ISU",
      "Iowa State"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#c8102e",
    "alternateColor": "#f1be48",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/66.png",
      "https://cdn.collegefootballdata.com/logos/256/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/66.png",
      "https://cdn.collegefootballdata.com/logos/128/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/66.png",
      "https://cdn.collegefootballdata.com/logos/96/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/66.png",
      "https://cdn.collegefootballdata.com/logos/64/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/66.png",
      "https://cdn.collegefootballdata.com/logos/48/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/66.png",
      "https://cdn.collegefootballdata.com/logos/32/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/66.png",
      "https://cdn.collegefootballdata.com/logos/16/66.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/66.png"
    ],
    "twitter": "@CycloneFB",
    "location": {
      "id": 3772,
      "name": "Jack Trice Stadium",
      "city": "Ames",
      "state": "IA",
      "zip": "50011",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 42.0139977,
      "longitude": -93.6357716,
      "elevation": "274.9135437",
      "capacity": 61500,
      "constructionYear": 1975,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 55,
    "school": "Jacksonville State",
    "mascot": "Gamecocks",
    "abbreviation": "JXST",
    "alternateNames": [
      "JXST",
      "Jax State"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#cc0000",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/55.png",
      "https://cdn.collegefootballdata.com/logos/256/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/55.png",
      "https://cdn.collegefootballdata.com/logos/128/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/55.png",
      "https://cdn.collegefootballdata.com/logos/96/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/55.png",
      "https://cdn.collegefootballdata.com/logos/64/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/55.png",
      "https://cdn.collegefootballdata.com/logos/48/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/55.png",
      "https://cdn.collegefootballdata.com/logos/32/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/55.png",
      "https://cdn.collegefootballdata.com/logos/16/55.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/55.png"
    ],
    "twitter": "@JSUGamecocksFB",
    "location": {
      "id": 3662,
      "name": "AmFirst Stadium",
      "city": "Jacksonville",
      "state": "AL",
      "zip": "36265",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.8201052,
      "longitude": -85.76647,
      "elevation": "198.0679016",
      "capacity": 24000,
      "constructionYear": 1947,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 256,
    "school": "James Madison",
    "mascot": "Dukes",
    "abbreviation": "JMU",
    "alternateNames": [
      "JMU",
      "James Madison"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#450084",
    "alternateColor": "#cbb677",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/256.png",
      "https://cdn.collegefootballdata.com/logos/256/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/256.png",
      "https://cdn.collegefootballdata.com/logos/128/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/256.png",
      "https://cdn.collegefootballdata.com/logos/96/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/256.png",
      "https://cdn.collegefootballdata.com/logos/64/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/256.png",
      "https://cdn.collegefootballdata.com/logos/48/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/256.png",
      "https://cdn.collegefootballdata.com/logos/32/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/256.png",
      "https://cdn.collegefootballdata.com/logos/16/256.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/256.png"
    ],
    "twitter": "@JMUFootball",
    "location": {
      "id": 3651,
      "name": "Bridgeforth Stadium",
      "city": "Harrisonburg",
      "state": "VA",
      "zip": "22807",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.4352919,
      "longitude": -78.8729349,
      "elevation": "399.303009",
      "capacity": 24877,
      "constructionYear": 1975,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2305,
    "school": "Kansas",
    "mascot": "Jayhawks",
    "abbreviation": "KU",
    "alternateNames": [
      "KU",
      "Kansas"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#0051ba",
    "alternateColor": "#e8000d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2305.png",
      "https://cdn.collegefootballdata.com/logos/256/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2305.png",
      "https://cdn.collegefootballdata.com/logos/128/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2305.png",
      "https://cdn.collegefootballdata.com/logos/96/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2305.png",
      "https://cdn.collegefootballdata.com/logos/64/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2305.png",
      "https://cdn.collegefootballdata.com/logos/48/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2305.png",
      "https://cdn.collegefootballdata.com/logos/32/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2305.png",
      "https://cdn.collegefootballdata.com/logos/16/2305.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2305.png"
    ],
    "twitter": "@KU_Football",
    "location": {
      "id": 3833,
      "name": "Memorial Stadium",
      "city": "Lawrence",
      "state": "KS",
      "zip": "66045",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 38.9629418,
      "longitude": -95.2463686,
      "elevation": "274.855957",
      "capacity": 47000,
      "constructionYear": 1921,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2306,
    "school": "Kansas State",
    "mascot": "Wildcats",
    "abbreviation": "KSU",
    "alternateNames": [
      "KSU",
      "Kansas St"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#512888",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2306.png",
      "https://cdn.collegefootballdata.com/logos/256/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2306.png",
      "https://cdn.collegefootballdata.com/logos/128/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2306.png",
      "https://cdn.collegefootballdata.com/logos/96/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2306.png",
      "https://cdn.collegefootballdata.com/logos/64/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2306.png",
      "https://cdn.collegefootballdata.com/logos/48/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2306.png",
      "https://cdn.collegefootballdata.com/logos/32/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2306.png",
      "https://cdn.collegefootballdata.com/logos/16/2306.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2306.png"
    ],
    "twitter": "@KStateFB",
    "location": {
      "id": 3636,
      "name": "Bill Snyder Family Stadium",
      "city": "Manhattan",
      "state": "KS",
      "zip": "66502",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 39.2020096,
      "longitude": -96.5938395,
      "elevation": "328.0574646",
      "capacity": 50000,
      "constructionYear": 1968,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 338,
    "school": "Kennesaw State",
    "mascot": "Owls",
    "abbreviation": "KENN",
    "alternateNames": [
      "Kennesaw",
      "KENN",
      "Kennesaw St"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#fdbb30",
    "alternateColor": "#0b1315",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/338.png",
      "https://cdn.collegefootballdata.com/logos/256/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/338.png",
      "https://cdn.collegefootballdata.com/logos/128/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/338.png",
      "https://cdn.collegefootballdata.com/logos/96/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/338.png",
      "https://cdn.collegefootballdata.com/logos/64/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/338.png",
      "https://cdn.collegefootballdata.com/logos/48/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/338.png",
      "https://cdn.collegefootballdata.com/logos/32/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/338.png",
      "https://cdn.collegefootballdata.com/logos/16/338.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/338.png"
    ],
    "twitter": "@KennesawStFB",
    "location": {
      "id": 4899,
      "name": "Fifth Third Stadium",
      "city": "Kennesaw",
      "state": "GA",
      "zip": "30144",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 34.0289318,
      "longitude": -84.5676234,
      "elevation": "296.9589844",
      "capacity": 11040,
      "constructionYear": 2010,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2309,
    "school": "Kent State",
    "mascot": "Golden Flashes",
    "abbreviation": "KENT",
    "alternateNames": [
      "KENT",
      "Kent State"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#002664",
    "alternateColor": "#eaab00",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2309.png",
      "https://cdn.collegefootballdata.com/logos/256/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2309.png",
      "https://cdn.collegefootballdata.com/logos/128/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2309.png",
      "https://cdn.collegefootballdata.com/logos/96/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2309.png",
      "https://cdn.collegefootballdata.com/logos/64/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2309.png",
      "https://cdn.collegefootballdata.com/logos/48/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2309.png",
      "https://cdn.collegefootballdata.com/logos/32/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2309.png",
      "https://cdn.collegefootballdata.com/logos/16/2309.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2309.png"
    ],
    "twitter": "@KentStFootball",
    "location": {
      "id": 3696,
      "name": "Dix Stadium",
      "city": "Kent",
      "state": "OH",
      "zip": "44242",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.1390935,
      "longitude": -81.31346,
      "elevation": "321.3641663",
      "capacity": 25319,
      "constructionYear": 1969,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 96,
    "school": "Kentucky",
    "mascot": "Wildcats",
    "abbreviation": "UK",
    "alternateNames": [
      "UK",
      "Kentucky"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#0033a0",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/96.png",
      "https://cdn.collegefootballdata.com/logos/256/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/96.png",
      "https://cdn.collegefootballdata.com/logos/128/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/96.png",
      "https://cdn.collegefootballdata.com/logos/96/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/96.png",
      "https://cdn.collegefootballdata.com/logos/64/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/96.png",
      "https://cdn.collegefootballdata.com/logos/48/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/96.png",
      "https://cdn.collegefootballdata.com/logos/32/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/96.png",
      "https://cdn.collegefootballdata.com/logos/16/96.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/96.png"
    ],
    "twitter": "@UKFootball",
    "location": {
      "id": 3683,
      "name": "Kroger Field",
      "city": "Lexington",
      "state": "KY",
      "zip": "40506",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.0220905,
      "longitude": -84.5053408,
      "elevation": "307.4248962",
      "capacity": 61000,
      "constructionYear": 1973,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2335,
    "school": "Liberty",
    "mascot": "Flames",
    "abbreviation": "LIB",
    "alternateNames": [
      "LIB",
      "Liberty"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#0a254e",
    "alternateColor": "#b72025",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2335.png",
      "https://cdn.collegefootballdata.com/logos/256/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2335.png",
      "https://cdn.collegefootballdata.com/logos/128/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2335.png",
      "https://cdn.collegefootballdata.com/logos/96/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2335.png",
      "https://cdn.collegefootballdata.com/logos/64/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2335.png",
      "https://cdn.collegefootballdata.com/logos/48/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2335.png",
      "https://cdn.collegefootballdata.com/logos/32/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2335.png",
      "https://cdn.collegefootballdata.com/logos/16/2335.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2335.png"
    ],
    "twitter": "@LibertyFootball",
    "location": {
      "id": 3992,
      "name": "Williams Stadium (VA)",
      "city": "Lynchburg",
      "state": "VA",
      "zip": "24502",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 37.3544305,
      "longitude": -79.1750239,
      "elevation": "272.9237061",
      "capacity": 25000,
      "constructionYear": 1989,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 309,
    "school": "Louisiana",
    "mascot": "Ragin' Cajuns",
    "abbreviation": "UL",
    "alternateNames": [
      "UL Lafayette",
      "UL",
      "Louisiana"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#ce181e",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/309.png",
      "https://cdn.collegefootballdata.com/logos/256/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/309.png",
      "https://cdn.collegefootballdata.com/logos/128/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/309.png",
      "https://cdn.collegefootballdata.com/logos/96/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/309.png",
      "https://cdn.collegefootballdata.com/logos/64/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/309.png",
      "https://cdn.collegefootballdata.com/logos/48/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/309.png",
      "https://cdn.collegefootballdata.com/logos/32/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/309.png",
      "https://cdn.collegefootballdata.com/logos/16/309.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/309.png"
    ],
    "twitter": "@RaginCajunsFB",
    "location": {
      "id": 3666,
      "name": "Cajun Field",
      "city": "Lafayette",
      "state": "LA",
      "zip": "70506",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.2158434,
      "longitude": -92.0417371,
      "elevation": "3.556508303",
      "capacity": 41426,
      "constructionYear": 1971,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2348,
    "school": "Louisiana Tech",
    "mascot": "Bulldogs",
    "abbreviation": "LT",
    "alternateNames": [
      "LT",
      "Louisiana Tech"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#003087",
    "alternateColor": "#cb333b",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2348.png",
      "https://cdn.collegefootballdata.com/logos/256/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2348.png",
      "https://cdn.collegefootballdata.com/logos/128/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2348.png",
      "https://cdn.collegefootballdata.com/logos/96/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2348.png",
      "https://cdn.collegefootballdata.com/logos/64/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2348.png",
      "https://cdn.collegefootballdata.com/logos/48/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2348.png",
      "https://cdn.collegefootballdata.com/logos/32/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2348.png",
      "https://cdn.collegefootballdata.com/logos/16/2348.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2348.png"
    ],
    "twitter": "@LATechFB",
    "location": {
      "id": 3776,
      "name": "Joe Aillet Stadium",
      "city": "Ruston",
      "state": "LA",
      "zip": "71272",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 32.5321487,
      "longitude": -92.6560019,
      "elevation": "72.87982941",
      "capacity": 28019,
      "constructionYear": 1968,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 97,
    "school": "Louisville",
    "mascot": "Cardinals",
    "abbreviation": "LOU",
    "alternateNames": [
      "LOU",
      "Louisville"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#c9001f",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/97.png",
      "https://cdn.collegefootballdata.com/logos/256/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/97.png",
      "https://cdn.collegefootballdata.com/logos/128/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/97.png",
      "https://cdn.collegefootballdata.com/logos/96/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/97.png",
      "https://cdn.collegefootballdata.com/logos/64/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/97.png",
      "https://cdn.collegefootballdata.com/logos/48/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/97.png",
      "https://cdn.collegefootballdata.com/logos/32/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/97.png",
      "https://cdn.collegefootballdata.com/logos/16/97.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/97.png"
    ],
    "twitter": "@LouisvilleFB",
    "location": {
      "id": 3873,
      "name": "L&N Federal Credit Union Stadium",
      "city": "Louisville",
      "state": "KY",
      "zip": "40292",
      "countryCode": "US",
      "timezone": "America/Kentucky/Louisville",
      "latitude": 38.2057621,
      "longitude": -85.7588141,
      "elevation": "138.5615997",
      "capacity": 60000,
      "constructionYear": 1998,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 99,
    "school": "LSU",
    "mascot": "Tigers",
    "abbreviation": "LSU",
    "alternateNames": [
      "Louisiana State",
      "LSU",
      "LSU"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#461d7c",
    "alternateColor": "#fdd023",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/99.png",
      "https://cdn.collegefootballdata.com/logos/256/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/99.png",
      "https://cdn.collegefootballdata.com/logos/128/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/99.png",
      "https://cdn.collegefootballdata.com/logos/96/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/99.png",
      "https://cdn.collegefootballdata.com/logos/64/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/99.png",
      "https://cdn.collegefootballdata.com/logos/48/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/99.png",
      "https://cdn.collegefootballdata.com/logos/32/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/99.png",
      "https://cdn.collegefootballdata.com/logos/16/99.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/99.png"
    ],
    "twitter": "@LSUFootball",
    "location": {
      "id": 3958,
      "name": "Tiger Stadium (LA)",
      "city": "Baton Rouge",
      "state": "LA",
      "zip": "70803",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.412035,
      "longitude": -91.1838163,
      "elevation": "7.640734673",
      "capacity": 102321,
      "constructionYear": 1924,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 276,
    "school": "Marshall",
    "mascot": "Thundering Herd",
    "abbreviation": "MRSH",
    "alternateNames": [
      "MRSH",
      "Marshall"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#00b140",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/276.png",
      "https://cdn.collegefootballdata.com/logos/256/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/276.png",
      "https://cdn.collegefootballdata.com/logos/128/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/276.png",
      "https://cdn.collegefootballdata.com/logos/96/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/276.png",
      "https://cdn.collegefootballdata.com/logos/64/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/276.png",
      "https://cdn.collegefootballdata.com/logos/48/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/276.png",
      "https://cdn.collegefootballdata.com/logos/32/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/276.png",
      "https://cdn.collegefootballdata.com/logos/16/276.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/276.png"
    ],
    "twitter": "@HerdFB",
    "location": {
      "id": 3775,
      "name": "Joan C. Edwards Stadium",
      "city": "Huntington",
      "state": "WV",
      "zip": "25755",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.4247042,
      "longitude": -82.4214412,
      "elevation": "163.7328186",
      "capacity": 38016,
      "constructionYear": 1991,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 120,
    "school": "Maryland",
    "mascot": "Terrapins",
    "abbreviation": "MD",
    "alternateNames": [
      "MD",
      "Maryland"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#ce1126",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/120.png",
      "https://cdn.collegefootballdata.com/logos/256/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/120.png",
      "https://cdn.collegefootballdata.com/logos/128/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/120.png",
      "https://cdn.collegefootballdata.com/logos/96/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/120.png",
      "https://cdn.collegefootballdata.com/logos/64/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/120.png",
      "https://cdn.collegefootballdata.com/logos/48/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/120.png",
      "https://cdn.collegefootballdata.com/logos/32/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/120.png",
      "https://cdn.collegefootballdata.com/logos/16/120.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/120.png"
    ],
    "twitter": "@TerpsFootball",
    "location": {
      "id": 3665,
      "name": "SECU Stadium",
      "city": "College Park",
      "state": "MD",
      "zip": "20742",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.9903332,
      "longitude": -76.9473792,
      "elevation": "32.68748093",
      "capacity": 51802,
      "constructionYear": 1950,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 113,
    "school": "Massachusetts",
    "mascot": "Minutemen",
    "abbreviation": "MASS",
    "alternateNames": [
      "UMass",
      "MASS",
      "UMass"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#881c1c",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/113.png",
      "https://cdn.collegefootballdata.com/logos/256/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/113.png",
      "https://cdn.collegefootballdata.com/logos/128/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/113.png",
      "https://cdn.collegefootballdata.com/logos/96/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/113.png",
      "https://cdn.collegefootballdata.com/logos/64/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/113.png",
      "https://cdn.collegefootballdata.com/logos/48/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/113.png",
      "https://cdn.collegefootballdata.com/logos/32/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/113.png",
      "https://cdn.collegefootballdata.com/logos/16/113.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/113.png"
    ],
    "twitter": "@UMassFootball",
    "location": {
      "id": 3985,
      "name": "Warren McGuirk Alumni Stadium",
      "city": "Hadley",
      "state": "MA",
      "zip": "1003 ",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 42.3773244,
      "longitude": -72.5360595,
      "elevation": "46.58664703",
      "capacity": 17000,
      "constructionYear": 1965,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 235,
    "school": "Memphis",
    "mascot": "Tigers",
    "abbreviation": "MEM",
    "alternateNames": [
      "MEM",
      "Memphis"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#00498f",
    "alternateColor": "#9c9ea1",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/235.png",
      "https://cdn.collegefootballdata.com/logos/256/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/235.png",
      "https://cdn.collegefootballdata.com/logos/128/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/235.png",
      "https://cdn.collegefootballdata.com/logos/96/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/235.png",
      "https://cdn.collegefootballdata.com/logos/64/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/235.png",
      "https://cdn.collegefootballdata.com/logos/48/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/235.png",
      "https://cdn.collegefootballdata.com/logos/32/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/235.png",
      "https://cdn.collegefootballdata.com/logos/16/235.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/235.png"
    ],
    "twitter": "@MemphisFB",
    "location": {
      "id": 3805,
      "name": "Simmons Bank Liberty Stadium",
      "city": "Memphis",
      "state": "TN",
      "zip": "38152",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 35.1209429,
      "longitude": -89.977147,
      "elevation": "90.62445831",
      "capacity": 58325,
      "constructionYear": 1965,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2390,
    "school": "Miami",
    "mascot": "Hurricanes",
    "abbreviation": "MIA",
    "alternateNames": [
      "Miami (FL)",
      "MIA",
      "Miami"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#f47321",
    "alternateColor": "#005030",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2390.png",
      "https://cdn.collegefootballdata.com/logos/256/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2390.png",
      "https://cdn.collegefootballdata.com/logos/128/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2390.png",
      "https://cdn.collegefootballdata.com/logos/96/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2390.png",
      "https://cdn.collegefootballdata.com/logos/64/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2390.png",
      "https://cdn.collegefootballdata.com/logos/48/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2390.png",
      "https://cdn.collegefootballdata.com/logos/32/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2390.png",
      "https://cdn.collegefootballdata.com/logos/16/2390.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2390.png"
    ],
    "twitter": "@CanesFootball",
    "location": {
      "id": 3948,
      "name": "Hard Rock Stadium",
      "city": "Miami Gardens",
      "state": "FL",
      "zip": "33299",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 25.9579665,
      "longitude": -80.2388604,
      "elevation": "2.624486446",
      "capacity": 64767,
      "constructionYear": 1987,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 193,
    "school": "Miami (OH)",
    "mascot": "RedHawks",
    "abbreviation": "M-OH",
    "alternateNames": [
      "M-OH",
      "Miami OH"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#c41230",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/193.png",
      "https://cdn.collegefootballdata.com/logos/256/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/193.png",
      "https://cdn.collegefootballdata.com/logos/128/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/193.png",
      "https://cdn.collegefootballdata.com/logos/96/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/193.png",
      "https://cdn.collegefootballdata.com/logos/64/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/193.png",
      "https://cdn.collegefootballdata.com/logos/48/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/193.png",
      "https://cdn.collegefootballdata.com/logos/32/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/193.png",
      "https://cdn.collegefootballdata.com/logos/16/193.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/193.png"
    ],
    "twitter": "@MiamiOHFootball",
    "location": {
      "id": 3996,
      "name": "Yager Stadium",
      "city": "Oxford",
      "state": "OH",
      "zip": "45056",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.5197009,
      "longitude": -84.7330255,
      "elevation": "242.2643585",
      "capacity": 24286,
      "constructionYear": 1983,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 130,
    "school": "Michigan",
    "mascot": "Wolverines",
    "abbreviation": "MICH",
    "alternateNames": [
      "MICH",
      "Michigan"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#00274c",
    "alternateColor": "#ffcb05",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/130.png",
      "https://cdn.collegefootballdata.com/logos/256/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/130.png",
      "https://cdn.collegefootballdata.com/logos/128/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/130.png",
      "https://cdn.collegefootballdata.com/logos/96/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/130.png",
      "https://cdn.collegefootballdata.com/logos/64/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/130.png",
      "https://cdn.collegefootballdata.com/logos/48/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/130.png",
      "https://cdn.collegefootballdata.com/logos/32/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/130.png",
      "https://cdn.collegefootballdata.com/logos/16/130.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/130.png"
    ],
    "twitter": "@UMichFootball",
    "location": {
      "id": 3558,
      "name": "Michigan Stadium",
      "city": "Ann Arbor",
      "state": "MI",
      "zip": "48109",
      "countryCode": "US",
      "timezone": "America/Detroit",
      "latitude": 42.2658365,
      "longitude": -83.7486956,
      "elevation": "255.5500031",
      "capacity": 107601,
      "constructionYear": 1927,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 127,
    "school": "Michigan State",
    "mascot": "Spartans",
    "abbreviation": "MSU",
    "alternateNames": [
      "MSU",
      "Michigan St"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#173f35",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/127.png",
      "https://cdn.collegefootballdata.com/logos/256/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/127.png",
      "https://cdn.collegefootballdata.com/logos/128/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/127.png",
      "https://cdn.collegefootballdata.com/logos/96/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/127.png",
      "https://cdn.collegefootballdata.com/logos/64/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/127.png",
      "https://cdn.collegefootballdata.com/logos/48/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/127.png",
      "https://cdn.collegefootballdata.com/logos/32/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/127.png",
      "https://cdn.collegefootballdata.com/logos/16/127.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/127.png"
    ],
    "twitter": "@MSU_Football",
    "location": {
      "id": 3936,
      "name": "Spartan Stadium",
      "city": "East Lansing",
      "state": "MI",
      "zip": "48824",
      "countryCode": "US",
      "timezone": "America/Detroit",
      "latitude": 42.7281474,
      "longitude": -84.4848526,
      "elevation": "254.8794861",
      "capacity": 75005,
      "constructionYear": 1923,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2393,
    "school": "Middle Tennessee",
    "mascot": "Blue Raiders",
    "abbreviation": "MTSU",
    "alternateNames": [
      "Middle Tennessee State",
      "MTSU",
      "MTSU"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#036eb7",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2393.png",
      "https://cdn.collegefootballdata.com/logos/256/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2393.png",
      "https://cdn.collegefootballdata.com/logos/128/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2393.png",
      "https://cdn.collegefootballdata.com/logos/96/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2393.png",
      "https://cdn.collegefootballdata.com/logos/64/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2393.png",
      "https://cdn.collegefootballdata.com/logos/48/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2393.png",
      "https://cdn.collegefootballdata.com/logos/32/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2393.png",
      "https://cdn.collegefootballdata.com/logos/16/2393.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2393.png"
    ],
    "twitter": "@MT_FB",
    "location": {
      "id": 3725,
      "name": "Johnny \"Red\" Floyd Stadium",
      "city": "Murfreesboro",
      "state": "TN",
      "zip": "37132",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 35.8511463,
      "longitude": -86.3681649,
      "elevation": "191.7279816",
      "capacity": 30788,
      "constructionYear": 1933,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 135,
    "school": "Minnesota",
    "mascot": "Golden Gophers",
    "abbreviation": "MINN",
    "alternateNames": [
      "MINN",
      "Minnesota"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#7a0019",
    "alternateColor": "#ffcc33",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/135.png",
      "https://cdn.collegefootballdata.com/logos/256/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/135.png",
      "https://cdn.collegefootballdata.com/logos/128/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/135.png",
      "https://cdn.collegefootballdata.com/logos/96/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/135.png",
      "https://cdn.collegefootballdata.com/logos/64/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/135.png",
      "https://cdn.collegefootballdata.com/logos/48/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/135.png",
      "https://cdn.collegefootballdata.com/logos/32/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/135.png",
      "https://cdn.collegefootballdata.com/logos/16/135.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/135.png"
    ],
    "twitter": "@GopherFootball",
    "location": {
      "id": 3953,
      "name": "Huntington Bank Stadium",
      "city": "Minneapolis",
      "state": "MN",
      "zip": "55488",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 44.976525,
      "longitude": -93.2245462,
      "elevation": "254.3902283",
      "capacity": 50850,
      "constructionYear": 2009,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 344,
    "school": "Mississippi State",
    "mascot": "Bulldogs",
    "abbreviation": "MSST",
    "alternateNames": [
      "MSST",
      "Mississippi St"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#5d1725",
    "alternateColor": "#c1c6c8",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/344.png",
      "https://cdn.collegefootballdata.com/logos/256/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/344.png",
      "https://cdn.collegefootballdata.com/logos/128/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/344.png",
      "https://cdn.collegefootballdata.com/logos/96/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/344.png",
      "https://cdn.collegefootballdata.com/logos/64/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/344.png",
      "https://cdn.collegefootballdata.com/logos/48/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/344.png",
      "https://cdn.collegefootballdata.com/logos/32/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/344.png",
      "https://cdn.collegefootballdata.com/logos/16/344.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/344.png"
    ],
    "twitter": "@HailStateFB",
    "location": {
      "id": 3693,
      "name": "Davis Wade Stadium",
      "city": "Starkville",
      "state": "MS",
      "zip": "39762",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.4563403,
      "longitude": -88.7933652,
      "elevation": "110.2742081",
      "capacity": 61337,
      "constructionYear": 1914,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 142,
    "school": "Missouri",
    "mascot": "Tigers",
    "abbreviation": "MIZ",
    "alternateNames": [
      "MIZ",
      "Missouri"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#f1b82d",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/142.png",
      "https://cdn.collegefootballdata.com/logos/256/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/142.png",
      "https://cdn.collegefootballdata.com/logos/128/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/142.png",
      "https://cdn.collegefootballdata.com/logos/96/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/142.png",
      "https://cdn.collegefootballdata.com/logos/64/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/142.png",
      "https://cdn.collegefootballdata.com/logos/48/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/142.png",
      "https://cdn.collegefootballdata.com/logos/32/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/142.png",
      "https://cdn.collegefootballdata.com/logos/16/142.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/142.png"
    ],
    "twitter": "@MizzouFootball",
    "location": {
      "id": 3838,
      "name": "Memorial Stadium",
      "city": "Columbia",
      "state": "MO",
      "zip": "65211",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 38.9358491,
      "longitude": -92.3332009,
      "elevation": "212.6865692",
      "capacity": 71168,
      "constructionYear": 1927,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2623,
    "school": "Missouri State",
    "mascot": "Bears",
    "abbreviation": "MOST",
    "alternateNames": [
      "MOST",
      "Missouri St"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#5e0009",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2623.png",
      "https://cdn.collegefootballdata.com/logos/256/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2623.png",
      "https://cdn.collegefootballdata.com/logos/128/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2623.png",
      "https://cdn.collegefootballdata.com/logos/96/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2623.png",
      "https://cdn.collegefootballdata.com/logos/64/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2623.png",
      "https://cdn.collegefootballdata.com/logos/48/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2623.png",
      "https://cdn.collegefootballdata.com/logos/32/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2623.png",
      "https://cdn.collegefootballdata.com/logos/16/2623.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2623.png"
    ],
    "twitter": "@MOStateFootball",
    "location": {
      "id": 3878,
      "name": "Plaster Sports Complex",
      "city": "Springfield",
      "state": "MO",
      "zip": "65897",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 37.1976229,
      "longitude": -93.2798119,
      "elevation": "402.368103",
      "capacity": 17337,
      "constructionYear": 1941,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2426,
    "school": "Navy",
    "mascot": "Midshipmen",
    "abbreviation": "NAVY",
    "alternateNames": [
      "NAVY",
      "Navy"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#00225b",
    "alternateColor": "#b5a67c",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2426.png",
      "https://cdn.collegefootballdata.com/logos/256/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2426.png",
      "https://cdn.collegefootballdata.com/logos/128/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2426.png",
      "https://cdn.collegefootballdata.com/logos/96/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2426.png",
      "https://cdn.collegefootballdata.com/logos/64/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2426.png",
      "https://cdn.collegefootballdata.com/logos/48/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2426.png",
      "https://cdn.collegefootballdata.com/logos/32/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2426.png",
      "https://cdn.collegefootballdata.com/logos/16/2426.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2426.png"
    ],
    "twitter": "@NavyFB",
    "location": {
      "id": 3852,
      "name": "Navy-Marine Corps Memorial Stadium",
      "city": "Annapolis",
      "state": "MD",
      "zip": "21402",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.9846985,
      "longitude": -76.5076335,
      "elevation": "10.74990082",
      "capacity": 34000,
      "constructionYear": 1959,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 152,
    "school": "NC State",
    "mascot": "Wolfpack",
    "abbreviation": "NCSU",
    "alternateNames": [
      "North Carolina St.",
      "NCSU",
      "NC State"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#cc0000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/152.png",
      "https://cdn.collegefootballdata.com/logos/256/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/152.png",
      "https://cdn.collegefootballdata.com/logos/128/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/152.png",
      "https://cdn.collegefootballdata.com/logos/96/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/152.png",
      "https://cdn.collegefootballdata.com/logos/64/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/152.png",
      "https://cdn.collegefootballdata.com/logos/48/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/152.png",
      "https://cdn.collegefootballdata.com/logos/32/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/152.png",
      "https://cdn.collegefootballdata.com/logos/16/152.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/152.png"
    ],
    "twitter": "@PackFootball",
    "location": {
      "id": 3670,
      "name": "Carter-Finley Stadium",
      "city": "Raleigh",
      "state": "NC",
      "zip": "27695",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.8008001,
      "longitude": -78.7195655,
      "elevation": "117.0089951",
      "capacity": 58000,
      "constructionYear": 1966,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 158,
    "school": "Nebraska",
    "mascot": "Cornhuskers",
    "abbreviation": "NEB",
    "alternateNames": [
      "NEB",
      "Nebraska"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#d00000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/158.png",
      "https://cdn.collegefootballdata.com/logos/256/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/158.png",
      "https://cdn.collegefootballdata.com/logos/128/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/158.png",
      "https://cdn.collegefootballdata.com/logos/96/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/158.png",
      "https://cdn.collegefootballdata.com/logos/64/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/158.png",
      "https://cdn.collegefootballdata.com/logos/48/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/158.png",
      "https://cdn.collegefootballdata.com/logos/32/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/158.png",
      "https://cdn.collegefootballdata.com/logos/16/158.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/158.png"
    ],
    "twitter": "@HuskerFBNation",
    "location": {
      "id": 3834,
      "name": "Memorial Stadium (Lincoln, NE)",
      "city": "Lincoln",
      "state": "NE",
      "zip": "68588",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 40.820682,
      "longitude": -96.705594,
      "elevation": "354.9318848",
      "capacity": 85458,
      "constructionYear": 1923,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2440,
    "school": "Nevada",
    "mascot": "Wolf Pack",
    "abbreviation": "NEV",
    "alternateNames": [
      "NEV",
      "Nevada"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#041e42",
    "alternateColor": "#8a8d8f",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2440.png",
      "https://cdn.collegefootballdata.com/logos/256/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2440.png",
      "https://cdn.collegefootballdata.com/logos/128/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2440.png",
      "https://cdn.collegefootballdata.com/logos/96/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2440.png",
      "https://cdn.collegefootballdata.com/logos/64/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2440.png",
      "https://cdn.collegefootballdata.com/logos/48/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2440.png",
      "https://cdn.collegefootballdata.com/logos/32/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2440.png",
      "https://cdn.collegefootballdata.com/logos/16/2440.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2440.png"
    ],
    "twitter": "@NevadaFootball",
    "location": {
      "id": 3816,
      "name": "Mackay Stadium",
      "city": "Reno",
      "state": "NV",
      "zip": "89557",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 39.5469459,
      "longitude": -119.8175435,
      "elevation": "1406.57605",
      "capacity": 27000,
      "constructionYear": 1966,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 167,
    "school": "New Mexico",
    "mascot": "Lobos",
    "abbreviation": "UNM",
    "alternateNames": [
      "UNM",
      "New Mexico"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#ba0c2f",
    "alternateColor": "#a7a8aa",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/167.png",
      "https://cdn.collegefootballdata.com/logos/256/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/167.png",
      "https://cdn.collegefootballdata.com/logos/128/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/167.png",
      "https://cdn.collegefootballdata.com/logos/96/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/167.png",
      "https://cdn.collegefootballdata.com/logos/64/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/167.png",
      "https://cdn.collegefootballdata.com/logos/48/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/167.png",
      "https://cdn.collegefootballdata.com/logos/32/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/167.png",
      "https://cdn.collegefootballdata.com/logos/16/167.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/167.png"
    ],
    "twitter": "@UNMLoboFB",
    "location": {
      "id": 3971,
      "name": "University Stadium (NM)",
      "city": "Albuquerque",
      "state": "NM",
      "zip": "87131",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 35.0669479,
      "longitude": -106.6283225,
      "elevation": "1554.471924",
      "capacity": 39224,
      "constructionYear": 1960,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 166,
    "school": "New Mexico State",
    "mascot": "Aggies",
    "abbreviation": "NMSU",
    "alternateNames": [
      "NMSU",
      "New Mexico St"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#8c0b42",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/166.png",
      "https://cdn.collegefootballdata.com/logos/256/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/166.png",
      "https://cdn.collegefootballdata.com/logos/128/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/166.png",
      "https://cdn.collegefootballdata.com/logos/96/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/166.png",
      "https://cdn.collegefootballdata.com/logos/64/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/166.png",
      "https://cdn.collegefootballdata.com/logos/48/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/166.png",
      "https://cdn.collegefootballdata.com/logos/32/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/166.png",
      "https://cdn.collegefootballdata.com/logos/16/166.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/166.png"
    ],
    "twitter": "@NMStateFootball",
    "location": {
      "id": 3601,
      "name": "Aggie Memorial Stadium",
      "city": "Las Cruces",
      "state": "NM",
      "zip": "88003",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 32.2796202,
      "longitude": -106.7411148,
      "elevation": "1208.201294",
      "capacity": 28853,
      "constructionYear": 1978,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 153,
    "school": "North Carolina",
    "mascot": "Tar Heels",
    "abbreviation": "UNC",
    "alternateNames": [
      "UNC",
      "North Carolina"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#7bafd4",
    "alternateColor": "#13294b",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/153.png",
      "https://cdn.collegefootballdata.com/logos/256/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/153.png",
      "https://cdn.collegefootballdata.com/logos/128/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/153.png",
      "https://cdn.collegefootballdata.com/logos/96/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/153.png",
      "https://cdn.collegefootballdata.com/logos/64/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/153.png",
      "https://cdn.collegefootballdata.com/logos/48/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/153.png",
      "https://cdn.collegefootballdata.com/logos/32/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/153.png",
      "https://cdn.collegefootballdata.com/logos/16/153.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/153.png"
    ],
    "twitter": "@UNCFootball",
    "location": {
      "id": 3787,
      "name": "Kenan Stadium",
      "city": "Chapel Hill",
      "state": "NC",
      "zip": "27515",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.9069294,
      "longitude": -79.0478889,
      "elevation": "127.7569809",
      "capacity": 50500,
      "constructionYear": 1927,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2449,
    "school": "North Dakota State",
    "mascot": "Bison",
    "abbreviation": "NDSU",
    "alternateNames": [
      "NDSU",
      "N Dakota St"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#00583d",
    "alternateColor": "#ffc425",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2449.png",
      "https://cdn.collegefootballdata.com/logos/256/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2449.png",
      "https://cdn.collegefootballdata.com/logos/128/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2449.png",
      "https://cdn.collegefootballdata.com/logos/96/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2449.png",
      "https://cdn.collegefootballdata.com/logos/64/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2449.png",
      "https://cdn.collegefootballdata.com/logos/48/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2449.png",
      "https://cdn.collegefootballdata.com/logos/32/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2449.png",
      "https://cdn.collegefootballdata.com/logos/16/2449.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2449.png"
    ],
    "twitter": "@NDSUFootball",
    "location": {
      "id": 3714,
      "name": "Fargodome",
      "city": "Fargo",
      "state": "ND",
      "zip": "51802",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 46.9029938,
      "longitude": -96.8003251,
      "elevation": "274.4847717",
      "capacity": 18700,
      "constructionYear": 1992,
      "grass": false,
      "dome": true
    }
  },
  {
    "id": 2459,
    "school": "Northern Illinois",
    "mascot": "Huskies",
    "abbreviation": "NIU",
    "alternateNames": [
      "NIU",
      "N Illinois"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#c8102e",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2459.png",
      "https://cdn.collegefootballdata.com/logos/256/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2459.png",
      "https://cdn.collegefootballdata.com/logos/128/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2459.png",
      "https://cdn.collegefootballdata.com/logos/96/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2459.png",
      "https://cdn.collegefootballdata.com/logos/64/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2459.png",
      "https://cdn.collegefootballdata.com/logos/48/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2459.png",
      "https://cdn.collegefootballdata.com/logos/32/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2459.png",
      "https://cdn.collegefootballdata.com/logos/16/2459.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2459.png"
    ],
    "twitter": "@NIU_Football",
    "location": {
      "id": 3764,
      "name": "Huskie Stadium",
      "city": "DeKalb",
      "state": "IL",
      "zip": "60115",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 41.9339586,
      "longitude": -88.7778357,
      "elevation": "267.4530029",
      "capacity": 23595,
      "constructionYear": 1965,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 249,
    "school": "North Texas",
    "mascot": "Mean Green",
    "abbreviation": "UNT",
    "alternateNames": [
      "UNT",
      "North Texas"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#00853e",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/249.png",
      "https://cdn.collegefootballdata.com/logos/256/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/249.png",
      "https://cdn.collegefootballdata.com/logos/128/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/249.png",
      "https://cdn.collegefootballdata.com/logos/96/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/249.png",
      "https://cdn.collegefootballdata.com/logos/64/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/249.png",
      "https://cdn.collegefootballdata.com/logos/48/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/249.png",
      "https://cdn.collegefootballdata.com/logos/32/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/249.png",
      "https://cdn.collegefootballdata.com/logos/16/249.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/249.png"
    ],
    "twitter": "@MeanGreenFB",
    "location": {
      "id": 3825,
      "name": "DATCU Stadium",
      "city": "Denton",
      "state": "TX",
      "zip": "76210",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.203899,
      "longitude": -97.159245,
      "elevation": "198.6871948",
      "capacity": 30850,
      "constructionYear": 2011,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 77,
    "school": "Northwestern",
    "mascot": "Wildcats",
    "abbreviation": "NU",
    "alternateNames": [
      "NU",
      "Northwestern"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#582c83",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/77.png",
      "https://cdn.collegefootballdata.com/logos/256/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/77.png",
      "https://cdn.collegefootballdata.com/logos/128/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/77.png",
      "https://cdn.collegefootballdata.com/logos/96/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/77.png",
      "https://cdn.collegefootballdata.com/logos/64/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/77.png",
      "https://cdn.collegefootballdata.com/logos/48/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/77.png",
      "https://cdn.collegefootballdata.com/logos/32/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/77.png",
      "https://cdn.collegefootballdata.com/logos/16/77.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/77.png"
    ],
    "twitter": "@NUFBFamily",
    "location": {
      "id": 5960,
      "name": "Lanny and Sharon Martin Stadium",
      "city": "Evanston",
      "state": "IL",
      "zip": "60208",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 42.058246,
      "longitude": -87.670876,
      "elevation": "179",
      "capacity": 12023,
      "constructionYear": 1997,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 87,
    "school": "Notre Dame",
    "mascot": "Fighting Irish",
    "abbreviation": "ND",
    "alternateNames": [
      "ND",
      "Notre Dame"
    ],
    "conference": "FBS Independents",
    "division": null,
    "classification": "fbs",
    "color": "#0c2340",
    "alternateColor": "#c99700",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/87.png",
      "https://cdn.collegefootballdata.com/logos/256/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/87.png",
      "https://cdn.collegefootballdata.com/logos/128/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/87.png",
      "https://cdn.collegefootballdata.com/logos/96/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/87.png",
      "https://cdn.collegefootballdata.com/logos/64/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/87.png",
      "https://cdn.collegefootballdata.com/logos/48/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/87.png",
      "https://cdn.collegefootballdata.com/logos/32/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/87.png",
      "https://cdn.collegefootballdata.com/logos/16/87.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/87.png"
    ],
    "twitter": "@NDFootball",
    "location": {
      "id": 3855,
      "name": "Notre Dame Stadium",
      "city": "Notre Dame",
      "state": "IN",
      "zip": "46556",
      "countryCode": "US",
      "timezone": "America/Indiana/Indianapolis",
      "latitude": 41.698378,
      "longitude": -86.2339425,
      "elevation": "222.645401",
      "capacity": 80795,
      "constructionYear": 1930,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 195,
    "school": "Ohio",
    "mascot": "Bobcats",
    "abbreviation": "OHIO",
    "alternateNames": [
      "OHIO",
      "Ohio"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#024230",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/195.png",
      "https://cdn.collegefootballdata.com/logos/256/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/195.png",
      "https://cdn.collegefootballdata.com/logos/128/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/195.png",
      "https://cdn.collegefootballdata.com/logos/96/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/195.png",
      "https://cdn.collegefootballdata.com/logos/64/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/195.png",
      "https://cdn.collegefootballdata.com/logos/48/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/195.png",
      "https://cdn.collegefootballdata.com/logos/32/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/195.png",
      "https://cdn.collegefootballdata.com/logos/16/195.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/195.png"
    ],
    "twitter": "@OhioFootball",
    "location": {
      "id": 3876,
      "name": "Peden Stadium",
      "city": "Athens",
      "state": "OH",
      "zip": "45701",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.3212794,
      "longitude": -82.1034315,
      "elevation": "194.230896",
      "capacity": 24000,
      "constructionYear": 1929,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 194,
    "school": "Ohio State",
    "mascot": "Buckeyes",
    "abbreviation": "OSU",
    "alternateNames": [
      "OSU",
      "Ohio State"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#ba0c2f",
    "alternateColor": "#a7b1b7",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/194.png",
      "https://cdn.collegefootballdata.com/logos/256/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/194.png",
      "https://cdn.collegefootballdata.com/logos/128/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/194.png",
      "https://cdn.collegefootballdata.com/logos/96/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/194.png",
      "https://cdn.collegefootballdata.com/logos/64/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/194.png",
      "https://cdn.collegefootballdata.com/logos/48/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/194.png",
      "https://cdn.collegefootballdata.com/logos/32/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/194.png",
      "https://cdn.collegefootballdata.com/logos/16/194.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/194.png"
    ],
    "twitter": "@OhioStateFB",
    "location": {
      "id": 3861,
      "name": "Ohio Stadium",
      "city": "Columbus",
      "state": "OH",
      "zip": "43210",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 40.0016447,
      "longitude": -83.0197266,
      "elevation": "216.6770325",
      "capacity": 102780,
      "constructionYear": 1922,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 201,
    "school": "Oklahoma",
    "mascot": "Sooners",
    "abbreviation": "OU",
    "alternateNames": [
      "OU",
      "Oklahoma"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#841617",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/201.png",
      "https://cdn.collegefootballdata.com/logos/256/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/201.png",
      "https://cdn.collegefootballdata.com/logos/128/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/201.png",
      "https://cdn.collegefootballdata.com/logos/96/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/201.png",
      "https://cdn.collegefootballdata.com/logos/64/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/201.png",
      "https://cdn.collegefootballdata.com/logos/48/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/201.png",
      "https://cdn.collegefootballdata.com/logos/32/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/201.png",
      "https://cdn.collegefootballdata.com/logos/16/201.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/201.png"
    ],
    "twitter": "@OU_Football",
    "location": {
      "id": 3835,
      "name": "Memorial Stadium (Norman, OK)",
      "city": "Norman",
      "state": "OK",
      "zip": "73019",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 35.2058537,
      "longitude": -97.4423145,
      "elevation": "355.0962524",
      "capacity": 86112,
      "constructionYear": 1925,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 197,
    "school": "Oklahoma State",
    "mascot": "Cowboys",
    "abbreviation": "OKST",
    "alternateNames": [
      "OKST",
      "Oklahoma St"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#fe5c00",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/197.png",
      "https://cdn.collegefootballdata.com/logos/256/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/197.png",
      "https://cdn.collegefootballdata.com/logos/128/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/197.png",
      "https://cdn.collegefootballdata.com/logos/96/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/197.png",
      "https://cdn.collegefootballdata.com/logos/64/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/197.png",
      "https://cdn.collegefootballdata.com/logos/48/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/197.png",
      "https://cdn.collegefootballdata.com/logos/32/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/197.png",
      "https://cdn.collegefootballdata.com/logos/16/197.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/197.png"
    ],
    "twitter": "@CowboyFB",
    "location": {
      "id": 3646,
      "name": "Boone Pickens Stadium",
      "city": "Stillwater",
      "state": "OK",
      "zip": "74078",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 36.125673,
      "longitude": -97.066513,
      "elevation": "276.4808655",
      "capacity": 55509,
      "constructionYear": 1919,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 295,
    "school": "Old Dominion",
    "mascot": "Monarchs",
    "abbreviation": "ODU",
    "alternateNames": [
      "ODU",
      "Old Dominion"
    ],
    "conference": "Sun Belt",
    "division": "East",
    "classification": "fbs",
    "color": "#043657",
    "alternateColor": "#98c5ea",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/295.png",
      "https://cdn.collegefootballdata.com/logos/256/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/295.png",
      "https://cdn.collegefootballdata.com/logos/128/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/295.png",
      "https://cdn.collegefootballdata.com/logos/96/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/295.png",
      "https://cdn.collegefootballdata.com/logos/64/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/295.png",
      "https://cdn.collegefootballdata.com/logos/48/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/295.png",
      "https://cdn.collegefootballdata.com/logos/32/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/295.png",
      "https://cdn.collegefootballdata.com/logos/16/295.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/295.png"
    ],
    "twitter": "@ODUFootball",
    "location": {
      "id": 3918,
      "name": "S.B. Ballard Stadium",
      "city": "Norfolk",
      "state": "VA",
      "zip": "23551",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 36.8889533,
      "longitude": -76.3049175,
      "elevation": "3.147987843",
      "capacity": 20118,
      "constructionYear": 1936,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 145,
    "school": "Ole Miss",
    "mascot": "Rebels",
    "abbreviation": "MISS",
    "alternateNames": [
      "MISS",
      "Ole Miss"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#13294b",
    "alternateColor": "#cf142b",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/145.png",
      "https://cdn.collegefootballdata.com/logos/256/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/145.png",
      "https://cdn.collegefootballdata.com/logos/128/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/145.png",
      "https://cdn.collegefootballdata.com/logos/96/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/145.png",
      "https://cdn.collegefootballdata.com/logos/64/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/145.png",
      "https://cdn.collegefootballdata.com/logos/48/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/145.png",
      "https://cdn.collegefootballdata.com/logos/32/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/145.png",
      "https://cdn.collegefootballdata.com/logos/16/145.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/145.png"
    ],
    "twitter": "@OleMissFB",
    "location": {
      "id": 3974,
      "name": "Vaught-Hemingway Stadium",
      "city": "Oxford",
      "state": "MS",
      "zip": "38677",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 34.3619837,
      "longitude": -89.5342076,
      "elevation": "146.8517151",
      "capacity": 64038,
      "constructionYear": 1915,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2483,
    "school": "Oregon",
    "mascot": "Ducks",
    "abbreviation": "ORE",
    "alternateNames": [
      "ORE",
      "Oregon"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#007030",
    "alternateColor": "#fee11a",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2483.png",
      "https://cdn.collegefootballdata.com/logos/256/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2483.png",
      "https://cdn.collegefootballdata.com/logos/128/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2483.png",
      "https://cdn.collegefootballdata.com/logos/96/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2483.png",
      "https://cdn.collegefootballdata.com/logos/64/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2483.png",
      "https://cdn.collegefootballdata.com/logos/48/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2483.png",
      "https://cdn.collegefootballdata.com/logos/32/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2483.png",
      "https://cdn.collegefootballdata.com/logos/16/2483.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2483.png"
    ],
    "twitter": "@OregonFootball",
    "location": {
      "id": 3626,
      "name": "Autzen Stadium",
      "city": "Eugene",
      "state": "OR",
      "zip": "97401",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 44.0582712,
      "longitude": -123.0684883,
      "elevation": "127.4198303",
      "capacity": 54000,
      "constructionYear": 1967,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 204,
    "school": "Oregon State",
    "mascot": "Beavers",
    "abbreviation": "ORST",
    "alternateNames": [
      "ORST",
      "Oregon St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#dc4405",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/204.png",
      "https://cdn.collegefootballdata.com/logos/256/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/204.png",
      "https://cdn.collegefootballdata.com/logos/128/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/204.png",
      "https://cdn.collegefootballdata.com/logos/96/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/204.png",
      "https://cdn.collegefootballdata.com/logos/64/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/204.png",
      "https://cdn.collegefootballdata.com/logos/48/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/204.png",
      "https://cdn.collegefootballdata.com/logos/32/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/204.png",
      "https://cdn.collegefootballdata.com/logos/16/204.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/204.png"
    ],
    "twitter": "@BeaverFootball",
    "location": {
      "id": 3893,
      "name": "Reser Stadium",
      "city": "Corvallis",
      "state": "OR",
      "zip": "97331",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 44.5594559,
      "longitude": -123.2814341,
      "elevation": "66.90744781",
      "capacity": 43363,
      "constructionYear": 1953,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 213,
    "school": "Penn State",
    "mascot": "Nittany Lions",
    "abbreviation": "PSU",
    "alternateNames": [
      "PSU",
      "Penn State"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#001e44",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/213.png",
      "https://cdn.collegefootballdata.com/logos/256/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/213.png",
      "https://cdn.collegefootballdata.com/logos/128/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/213.png",
      "https://cdn.collegefootballdata.com/logos/96/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/213.png",
      "https://cdn.collegefootballdata.com/logos/64/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/213.png",
      "https://cdn.collegefootballdata.com/logos/48/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/213.png",
      "https://cdn.collegefootballdata.com/logos/32/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/213.png",
      "https://cdn.collegefootballdata.com/logos/16/213.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/213.png"
    ],
    "twitter": "@PennStateFball",
    "location": {
      "id": 3632,
      "name": "Beaver Stadium",
      "city": "University Park",
      "state": "PA",
      "zip": "16802",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 40.8121958,
      "longitude": -77.8561023,
      "elevation": "354.1551514",
      "capacity": 106572,
      "constructionYear": 1960,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 221,
    "school": "Pittsburgh",
    "mascot": "Panthers",
    "abbreviation": "PITT",
    "alternateNames": [
      "Pitt",
      "PITT",
      "Pitt"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#003594",
    "alternateColor": "#ffb81c",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/221.png",
      "https://cdn.collegefootballdata.com/logos/256/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/221.png",
      "https://cdn.collegefootballdata.com/logos/128/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/221.png",
      "https://cdn.collegefootballdata.com/logos/96/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/221.png",
      "https://cdn.collegefootballdata.com/logos/64/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/221.png",
      "https://cdn.collegefootballdata.com/logos/48/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/221.png",
      "https://cdn.collegefootballdata.com/logos/32/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/221.png",
      "https://cdn.collegefootballdata.com/logos/16/221.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/221.png"
    ],
    "twitter": "@Pitt_FB",
    "location": {
      "id": 3752,
      "name": "Acrisure Stadium",
      "city": "Pittsburgh",
      "state": "PA",
      "zip": "15260",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 40.4467648,
      "longitude": -80.0157603,
      "elevation": "220.5887146",
      "capacity": 68400,
      "constructionYear": 2001,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2509,
    "school": "Purdue",
    "mascot": "Boilermakers",
    "abbreviation": "PUR",
    "alternateNames": [
      "PUR",
      "Purdue"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#ceb888",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2509.png",
      "https://cdn.collegefootballdata.com/logos/256/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2509.png",
      "https://cdn.collegefootballdata.com/logos/128/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2509.png",
      "https://cdn.collegefootballdata.com/logos/96/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2509.png",
      "https://cdn.collegefootballdata.com/logos/64/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2509.png",
      "https://cdn.collegefootballdata.com/logos/48/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2509.png",
      "https://cdn.collegefootballdata.com/logos/32/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2509.png",
      "https://cdn.collegefootballdata.com/logos/16/2509.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2509.png"
    ],
    "twitter": "@BoilerFootball",
    "location": {
      "id": 3907,
      "name": "Ross-Ade Stadium",
      "city": "West Lafayette",
      "state": "IN",
      "zip": "47907",
      "countryCode": "US",
      "timezone": "America/Indiana/Indianapolis",
      "latitude": 40.4352253,
      "longitude": -86.9186843,
      "elevation": "197.5337677",
      "capacity": 57282,
      "constructionYear": 1924,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 242,
    "school": "Rice",
    "mascot": "Owls",
    "abbreviation": "RICE",
    "alternateNames": [
      "RICE",
      "Rice"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#00205b",
    "alternateColor": "#c1c6c8",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/242.png",
      "https://cdn.collegefootballdata.com/logos/256/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/242.png",
      "https://cdn.collegefootballdata.com/logos/128/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/242.png",
      "https://cdn.collegefootballdata.com/logos/96/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/242.png",
      "https://cdn.collegefootballdata.com/logos/64/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/242.png",
      "https://cdn.collegefootballdata.com/logos/48/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/242.png",
      "https://cdn.collegefootballdata.com/logos/32/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/242.png",
      "https://cdn.collegefootballdata.com/logos/16/242.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/242.png"
    ],
    "twitter": "@RiceFootball",
    "location": {
      "id": 3895,
      "name": "Rice Stadium",
      "city": "Houston",
      "state": "TX",
      "zip": "77251",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 29.7163297,
      "longitude": -95.4093261,
      "elevation": "7.148301601",
      "capacity": 47000,
      "constructionYear": 1950,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 164,
    "school": "Rutgers",
    "mascot": "Scarlet Knights",
    "abbreviation": "RUTG",
    "alternateNames": [
      "RUTG",
      "Rutgers"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#ce0e2d",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/164.png",
      "https://cdn.collegefootballdata.com/logos/256/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/164.png",
      "https://cdn.collegefootballdata.com/logos/128/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/164.png",
      "https://cdn.collegefootballdata.com/logos/96/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/164.png",
      "https://cdn.collegefootballdata.com/logos/64/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/164.png",
      "https://cdn.collegefootballdata.com/logos/48/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/164.png",
      "https://cdn.collegefootballdata.com/logos/32/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/164.png",
      "https://cdn.collegefootballdata.com/logos/16/164.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/164.png"
    ],
    "twitter": "@Rfootball",
    "location": {
      "id": 6577,
      "name": "SHI Stadium",
      "city": "Piscataway",
      "state": "NJ",
      "zip": "08854",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 40.513611,
      "longitude": -74.465278,
      "elevation": "19",
      "capacity": 52454,
      "constructionYear": 1994,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 16,
    "school": "Sacramento State",
    "mascot": "Hornets",
    "abbreviation": "SAC",
    "alternateNames": [
      "Cal State Sacramento",
      "SAC",
      "Sacramento St"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#00573c",
    "alternateColor": "#cdb97d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/16.png",
      "https://cdn.collegefootballdata.com/logos/256/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/16.png",
      "https://cdn.collegefootballdata.com/logos/128/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/16.png",
      "https://cdn.collegefootballdata.com/logos/96/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/16.png",
      "https://cdn.collegefootballdata.com/logos/64/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/16.png",
      "https://cdn.collegefootballdata.com/logos/48/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/16.png",
      "https://cdn.collegefootballdata.com/logos/32/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/16.png",
      "https://cdn.collegefootballdata.com/logos/16/16.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/16.png"
    ],
    "twitter": "@SacHornetsFB",
    "location": {
      "id": 3757,
      "name": "Hornet Stadium",
      "city": "Sacramento",
      "state": "CA",
      "zip": "95819",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 38.5556718,
      "longitude": -121.4229607,
      "elevation": "12.30015659",
      "capacity": 21195,
      "constructionYear": 1969,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2534,
    "school": "Sam Houston",
    "mascot": "Bearkats",
    "abbreviation": "SHSU",
    "alternateNames": [
      "Sam Houston State",
      "SHSU",
      "Sam Houston"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#f56423",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2534.png",
      "https://cdn.collegefootballdata.com/logos/256/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2534.png",
      "https://cdn.collegefootballdata.com/logos/128/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2534.png",
      "https://cdn.collegefootballdata.com/logos/96/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2534.png",
      "https://cdn.collegefootballdata.com/logos/64/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2534.png",
      "https://cdn.collegefootballdata.com/logos/48/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2534.png",
      "https://cdn.collegefootballdata.com/logos/32/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2534.png",
      "https://cdn.collegefootballdata.com/logos/16/2534.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2534.png"
    ],
    "twitter": "@BearkatsFB",
    "location": {
      "id": 3647,
      "name": "Elliott T. Bowers Stadium",
      "city": "Huntsville",
      "state": "TX",
      "zip": "77340",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.713926,
      "longitude": -95.5419802,
      "elevation": "127.6225204",
      "capacity": 14000,
      "constructionYear": 1986,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 21,
    "school": "San Diego State",
    "mascot": "Aztecs",
    "abbreviation": "SDSU",
    "alternateNames": [
      "SDSU",
      "San Diego St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#a6192e",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/21.png",
      "https://cdn.collegefootballdata.com/logos/256/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/21.png",
      "https://cdn.collegefootballdata.com/logos/128/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/21.png",
      "https://cdn.collegefootballdata.com/logos/96/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/21.png",
      "https://cdn.collegefootballdata.com/logos/64/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/21.png",
      "https://cdn.collegefootballdata.com/logos/48/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/21.png",
      "https://cdn.collegefootballdata.com/logos/32/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/21.png",
      "https://cdn.collegefootballdata.com/logos/16/21.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/21.png"
    ],
    "twitter": "@AztecFB",
    "location": {
      "id": 7311,
      "name": "Snapdragon Stadium",
      "city": "San Diego",
      "state": "CA",
      "zip": "92093",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 32.784444,
      "longitude": -117.122833,
      "elevation": "62",
      "capacity": 35000,
      "constructionYear": 2022,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 23,
    "school": "San José State",
    "mascot": "Spartans",
    "abbreviation": "SJSU",
    "alternateNames": [
      "San Jose St.",
      "SJSU",
      "San José St"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#0055a2",
    "alternateColor": "#e5a823",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/23.png",
      "https://cdn.collegefootballdata.com/logos/256/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/23.png",
      "https://cdn.collegefootballdata.com/logos/128/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/23.png",
      "https://cdn.collegefootballdata.com/logos/96/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/23.png",
      "https://cdn.collegefootballdata.com/logos/64/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/23.png",
      "https://cdn.collegefootballdata.com/logos/48/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/23.png",
      "https://cdn.collegefootballdata.com/logos/32/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/23.png",
      "https://cdn.collegefootballdata.com/logos/16/23.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/23.png"
    ],
    "twitter": "@SanJoseStateFB",
    "location": {
      "id": 3935,
      "name": "CEFCU Stadium",
      "city": "San Jose",
      "state": "CA",
      "zip": "95112",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 37.3196675,
      "longitude": -121.8682962,
      "elevation": "28.30708694",
      "capacity": 30456,
      "constructionYear": 1933,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2567,
    "school": "SMU",
    "mascot": "Mustangs",
    "abbreviation": "SMU",
    "alternateNames": [
      "Southern Methodist",
      "SMU",
      "SMU"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#d70000",
    "alternateColor": "#0033a1",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2567.png",
      "https://cdn.collegefootballdata.com/logos/256/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2567.png",
      "https://cdn.collegefootballdata.com/logos/128/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2567.png",
      "https://cdn.collegefootballdata.com/logos/96/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2567.png",
      "https://cdn.collegefootballdata.com/logos/64/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2567.png",
      "https://cdn.collegefootballdata.com/logos/48/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2567.png",
      "https://cdn.collegefootballdata.com/logos/32/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2567.png",
      "https://cdn.collegefootballdata.com/logos/16/2567.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2567.png"
    ],
    "twitter": "@SMUFB",
    "location": {
      "id": 3735,
      "name": "Gerald J. Ford Stadium",
      "city": "University Park",
      "state": "TX",
      "zip": "75275",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 32.8377223,
      "longitude": -96.7827859,
      "elevation": "169.4058075",
      "capacity": 32000,
      "constructionYear": 2000,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 6,
    "school": "South Alabama",
    "mascot": "Jaguars",
    "abbreviation": "USA",
    "alternateNames": [
      "USA",
      "South Alabama"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#00205b",
    "alternateColor": "#bf0d3e",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/6.png",
      "https://cdn.collegefootballdata.com/logos/256/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/6.png",
      "https://cdn.collegefootballdata.com/logos/128/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/6.png",
      "https://cdn.collegefootballdata.com/logos/96/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/6.png",
      "https://cdn.collegefootballdata.com/logos/64/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/6.png",
      "https://cdn.collegefootballdata.com/logos/48/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/6.png",
      "https://cdn.collegefootballdata.com/logos/32/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/6.png",
      "https://cdn.collegefootballdata.com/logos/16/6.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/6.png"
    ],
    "twitter": "@SouthAlabamaFB",
    "location": {
      "id": 6526,
      "name": "Hancock Whitney Stadium",
      "city": "Mobile",
      "state": "AL",
      "zip": "36688",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.696904,
      "longitude": -88.192013,
      "elevation": "45",
      "capacity": 25450,
      "constructionYear": 2020,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2579,
    "school": "South Carolina",
    "mascot": "Gamecocks",
    "abbreviation": "SC",
    "alternateNames": [
      "SC",
      "South Carolina"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#73000a",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2579.png",
      "https://cdn.collegefootballdata.com/logos/256/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2579.png",
      "https://cdn.collegefootballdata.com/logos/128/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2579.png",
      "https://cdn.collegefootballdata.com/logos/96/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2579.png",
      "https://cdn.collegefootballdata.com/logos/64/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2579.png",
      "https://cdn.collegefootballdata.com/logos/48/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2579.png",
      "https://cdn.collegefootballdata.com/logos/32/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2579.png",
      "https://cdn.collegefootballdata.com/logos/16/2579.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2579.png"
    ],
    "twitter": "@GamecockFB",
    "location": {
      "id": 3994,
      "name": "Williams-Brice Stadium",
      "city": "Columbia",
      "state": "SC",
      "zip": "29208",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 33.9730239,
      "longitude": -81.0191726,
      "elevation": "60.54548645",
      "capacity": 80250,
      "constructionYear": 1934,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2572,
    "school": "Southern Miss",
    "mascot": "Golden Eagles",
    "abbreviation": "USM",
    "alternateNames": [
      "Southern Mississippi",
      "USM",
      "Southern Miss"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#ffc72c",
    "alternateColor": "#231f20",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2572.png",
      "https://cdn.collegefootballdata.com/logos/256/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2572.png",
      "https://cdn.collegefootballdata.com/logos/128/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2572.png",
      "https://cdn.collegefootballdata.com/logos/96/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2572.png",
      "https://cdn.collegefootballdata.com/logos/64/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2572.png",
      "https://cdn.collegefootballdata.com/logos/48/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2572.png",
      "https://cdn.collegefootballdata.com/logos/32/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2572.png",
      "https://cdn.collegefootballdata.com/logos/16/2572.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2572.png"
    ],
    "twitter": "@SouthernMissFB",
    "location": {
      "id": 3815,
      "name": "M. M. Roberts Stadium",
      "city": "Hattiesburg",
      "state": "MS",
      "zip": "39402",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 31.3289321,
      "longitude": -89.3318118,
      "elevation": "64.52726746",
      "capacity": 36000,
      "constructionYear": 1932,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 58,
    "school": "South Florida",
    "mascot": "Bulls",
    "abbreviation": "USF",
    "alternateNames": [
      "USF",
      "South Florida"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#006747",
    "alternateColor": "#cfc493",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/58.png",
      "https://cdn.collegefootballdata.com/logos/256/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/58.png",
      "https://cdn.collegefootballdata.com/logos/128/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/58.png",
      "https://cdn.collegefootballdata.com/logos/96/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/58.png",
      "https://cdn.collegefootballdata.com/logos/64/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/58.png",
      "https://cdn.collegefootballdata.com/logos/48/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/58.png",
      "https://cdn.collegefootballdata.com/logos/32/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/58.png",
      "https://cdn.collegefootballdata.com/logos/16/58.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/58.png"
    ],
    "twitter": "@USFFootball",
    "location": {
      "id": 3886,
      "name": "Raymond James Stadium",
      "city": "Tampa",
      "state": "FL",
      "zip": "33620",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 27.9758691,
      "longitude": -82.5033344,
      "elevation": "11.07972908",
      "capacity": 65828,
      "constructionYear": 1998,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 24,
    "school": "Stanford",
    "mascot": "Cardinal",
    "abbreviation": "STAN",
    "alternateNames": [
      "STAN",
      "Stanford"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#8c1515",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/24.png",
      "https://cdn.collegefootballdata.com/logos/256/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/24.png",
      "https://cdn.collegefootballdata.com/logos/128/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/24.png",
      "https://cdn.collegefootballdata.com/logos/96/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/24.png",
      "https://cdn.collegefootballdata.com/logos/64/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/24.png",
      "https://cdn.collegefootballdata.com/logos/48/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/24.png",
      "https://cdn.collegefootballdata.com/logos/32/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/24.png",
      "https://cdn.collegefootballdata.com/logos/16/24.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/24.png"
    ],
    "twitter": "@StanfordFball",
    "location": {
      "id": 3940,
      "name": "Stanford Stadium",
      "city": "Stanford",
      "state": "CA",
      "zip": "94305",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 37.4345556,
      "longitude": -122.1611271,
      "elevation": "18.38425636",
      "capacity": 50424,
      "constructionYear": 2006,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 183,
    "school": "Syracuse",
    "mascot": "Orange",
    "abbreviation": "SYR",
    "alternateNames": [
      "SYR",
      "Syracuse"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#f76900",
    "alternateColor": "#000e54",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/183.png",
      "https://cdn.collegefootballdata.com/logos/256/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/183.png",
      "https://cdn.collegefootballdata.com/logos/128/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/183.png",
      "https://cdn.collegefootballdata.com/logos/96/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/183.png",
      "https://cdn.collegefootballdata.com/logos/64/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/183.png",
      "https://cdn.collegefootballdata.com/logos/48/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/183.png",
      "https://cdn.collegefootballdata.com/logos/32/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/183.png",
      "https://cdn.collegefootballdata.com/logos/16/183.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/183.png"
    ],
    "twitter": "@CuseFootball",
    "location": {
      "id": 1964,
      "name": "JMA Wireless Dome",
      "city": "Syracuse",
      "state": "NY",
      "zip": "13244",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 43.0362269,
      "longitude": -76.1363161,
      "elevation": "162.6989746",
      "capacity": 49057,
      "constructionYear": 1980,
      "grass": false,
      "dome": true
    }
  },
  {
    "id": 2628,
    "school": "TCU",
    "mascot": "Horned Frogs",
    "abbreviation": "TCU",
    "alternateNames": [
      "Texas Christian",
      "TCU",
      "TCU"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#4d1979",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2628.png",
      "https://cdn.collegefootballdata.com/logos/256/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2628.png",
      "https://cdn.collegefootballdata.com/logos/128/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2628.png",
      "https://cdn.collegefootballdata.com/logos/96/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2628.png",
      "https://cdn.collegefootballdata.com/logos/64/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2628.png",
      "https://cdn.collegefootballdata.com/logos/48/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2628.png",
      "https://cdn.collegefootballdata.com/logos/32/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2628.png",
      "https://cdn.collegefootballdata.com/logos/16/2628.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2628.png"
    ],
    "twitter": "@TCUFootball",
    "location": {
      "id": 3616,
      "name": "Amon G. Carter Stadium",
      "city": "Fort Worth",
      "state": "TX",
      "zip": "76129",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 32.7096604,
      "longitude": -97.3680835,
      "elevation": "185.4387054",
      "capacity": 46000,
      "constructionYear": 1929,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 218,
    "school": "Temple",
    "mascot": "Owls",
    "abbreviation": "TEM",
    "alternateNames": [
      "TEM",
      "Temple"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#a41e35",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/218.png",
      "https://cdn.collegefootballdata.com/logos/256/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/218.png",
      "https://cdn.collegefootballdata.com/logos/128/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/218.png",
      "https://cdn.collegefootballdata.com/logos/96/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/218.png",
      "https://cdn.collegefootballdata.com/logos/64/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/218.png",
      "https://cdn.collegefootballdata.com/logos/48/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/218.png",
      "https://cdn.collegefootballdata.com/logos/32/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/218.png",
      "https://cdn.collegefootballdata.com/logos/16/218.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/218.png"
    ],
    "twitter": "@Temple_FB",
    "location": {
      "id": 3806,
      "name": "Lincoln Financial Field",
      "city": "Philadelphia",
      "state": "PA",
      "zip": "19122",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.9007995,
      "longitude": -75.1675414,
      "elevation": "3.198706865",
      "capacity": 69879,
      "constructionYear": 2003,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2633,
    "school": "Tennessee",
    "mascot": "Volunteers",
    "abbreviation": "TENN",
    "alternateNames": [
      "TENN",
      "Tennessee"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#ff8200",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2633.png",
      "https://cdn.collegefootballdata.com/logos/256/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2633.png",
      "https://cdn.collegefootballdata.com/logos/128/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2633.png",
      "https://cdn.collegefootballdata.com/logos/96/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2633.png",
      "https://cdn.collegefootballdata.com/logos/64/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2633.png",
      "https://cdn.collegefootballdata.com/logos/48/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2633.png",
      "https://cdn.collegefootballdata.com/logos/32/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2633.png",
      "https://cdn.collegefootballdata.com/logos/16/2633.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2633.png"
    ],
    "twitter": "@Vol_Football",
    "location": {
      "id": 3853,
      "name": "Neyland Stadium",
      "city": "Knoxville",
      "state": "TN",
      "zip": "37996",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 35.9550131,
      "longitude": -83.9250128,
      "elevation": "271.9517212",
      "capacity": 102455,
      "constructionYear": 1921,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 251,
    "school": "Texas",
    "mascot": "Longhorns",
    "abbreviation": "TEX",
    "alternateNames": [
      "TEX",
      "Texas"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#bf5700",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/251.png",
      "https://cdn.collegefootballdata.com/logos/256/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/251.png",
      "https://cdn.collegefootballdata.com/logos/128/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/251.png",
      "https://cdn.collegefootballdata.com/logos/96/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/251.png",
      "https://cdn.collegefootballdata.com/logos/64/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/251.png",
      "https://cdn.collegefootballdata.com/logos/48/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/251.png",
      "https://cdn.collegefootballdata.com/logos/32/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/251.png",
      "https://cdn.collegefootballdata.com/logos/16/251.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/251.png"
    ],
    "twitter": "@TexasFootball",
    "location": {
      "id": 3910,
      "name": "DKR-Texas Memorial Stadium",
      "city": "Austin",
      "state": "TX",
      "zip": "78712",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.2836813,
      "longitude": -97.7325345,
      "elevation": "160.3089447",
      "capacity": 100119,
      "constructionYear": 1924,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 245,
    "school": "Texas A&M",
    "mascot": "Aggies",
    "abbreviation": "TA&M",
    "alternateNames": [
      "TA&M",
      "Texas A&M"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#500000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/245.png",
      "https://cdn.collegefootballdata.com/logos/256/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/245.png",
      "https://cdn.collegefootballdata.com/logos/128/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/245.png",
      "https://cdn.collegefootballdata.com/logos/96/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/245.png",
      "https://cdn.collegefootballdata.com/logos/64/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/245.png",
      "https://cdn.collegefootballdata.com/logos/48/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/245.png",
      "https://cdn.collegefootballdata.com/logos/32/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/245.png",
      "https://cdn.collegefootballdata.com/logos/16/245.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/245.png"
    ],
    "twitter": "@AggieFootball",
    "location": {
      "id": 3795,
      "name": "Kyle Field",
      "city": "College Station",
      "state": "TX",
      "zip": "77843",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 30.6098891,
      "longitude": -96.3403828,
      "elevation": "108.824585",
      "capacity": 102733,
      "constructionYear": 1927,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 326,
    "school": "Texas State",
    "mascot": "Bobcats",
    "abbreviation": "TXST",
    "alternateNames": [
      "TXST",
      "Texas St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#501214",
    "alternateColor": "#6a5638",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/326.png",
      "https://cdn.collegefootballdata.com/logos/256/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/326.png",
      "https://cdn.collegefootballdata.com/logos/128/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/326.png",
      "https://cdn.collegefootballdata.com/logos/96/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/326.png",
      "https://cdn.collegefootballdata.com/logos/64/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/326.png",
      "https://cdn.collegefootballdata.com/logos/48/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/326.png",
      "https://cdn.collegefootballdata.com/logos/32/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/326.png",
      "https://cdn.collegefootballdata.com/logos/16/326.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/326.png"
    ],
    "twitter": "@TXStateFootball",
    "location": {
      "id": 3644,
      "name": "Bobcat Stadium (TX)",
      "city": "San Marcos",
      "state": "TX",
      "zip": "78666",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 29.8910008,
      "longitude": -97.9255735,
      "elevation": "177.8676453",
      "capacity": 30000,
      "constructionYear": 1981,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2641,
    "school": "Texas Tech",
    "mascot": "Red Raiders",
    "abbreviation": "TTU",
    "alternateNames": [
      "TTU",
      "Texas Tech"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#c30020",
    "alternateColor": "#000000",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2641.png",
      "https://cdn.collegefootballdata.com/logos/256/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2641.png",
      "https://cdn.collegefootballdata.com/logos/128/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2641.png",
      "https://cdn.collegefootballdata.com/logos/96/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2641.png",
      "https://cdn.collegefootballdata.com/logos/64/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2641.png",
      "https://cdn.collegefootballdata.com/logos/48/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2641.png",
      "https://cdn.collegefootballdata.com/logos/32/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2641.png",
      "https://cdn.collegefootballdata.com/logos/16/2641.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2641.png"
    ],
    "twitter": "@TexasTechFB",
    "location": {
      "id": 3784,
      "name": "Jones AT&T Stadium",
      "city": "Lubbock",
      "state": "TX",
      "zip": "79409",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.5910518,
      "longitude": -101.8728824,
      "elevation": "980.7632446",
      "capacity": 60454,
      "constructionYear": 1947,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2649,
    "school": "Toledo",
    "mascot": "Rockets",
    "abbreviation": "TOL",
    "alternateNames": [
      "TOL",
      "Toledo"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#0b2240",
    "alternateColor": "#ffcd00",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2649.png",
      "https://cdn.collegefootballdata.com/logos/256/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2649.png",
      "https://cdn.collegefootballdata.com/logos/128/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2649.png",
      "https://cdn.collegefootballdata.com/logos/96/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2649.png",
      "https://cdn.collegefootballdata.com/logos/64/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2649.png",
      "https://cdn.collegefootballdata.com/logos/48/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2649.png",
      "https://cdn.collegefootballdata.com/logos/32/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2649.png",
      "https://cdn.collegefootballdata.com/logos/16/2649.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2649.png"
    ],
    "twitter": "@ToledoFB",
    "location": {
      "id": 3739,
      "name": "Glass Bowl",
      "city": "Toledo",
      "state": "OH",
      "zip": "43606",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.6574777,
      "longitude": -83.6135652,
      "elevation": "181.4839783",
      "capacity": 26038,
      "constructionYear": 1937,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2653,
    "school": "Troy",
    "mascot": "Trojans",
    "abbreviation": "TROY",
    "alternateNames": [
      "TROY",
      "Troy"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#862633",
    "alternateColor": "#b1b1b1",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2653.png",
      "https://cdn.collegefootballdata.com/logos/256/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2653.png",
      "https://cdn.collegefootballdata.com/logos/128/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2653.png",
      "https://cdn.collegefootballdata.com/logos/96/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2653.png",
      "https://cdn.collegefootballdata.com/logos/64/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2653.png",
      "https://cdn.collegefootballdata.com/logos/48/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2653.png",
      "https://cdn.collegefootballdata.com/logos/32/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2653.png",
      "https://cdn.collegefootballdata.com/logos/16/2653.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2653.png"
    ],
    "twitter": "@TroyTrojansFB",
    "location": {
      "id": 3975,
      "name": "Veterans Memorial Stadium (AL)",
      "city": "Troy",
      "state": "AL",
      "zip": "36082",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 31.7995565,
      "longitude": -85.9518328,
      "elevation": "154.7746277",
      "capacity": 30000,
      "constructionYear": 1950,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2655,
    "school": "Tulane",
    "mascot": "Green Wave",
    "abbreviation": "TULN",
    "alternateNames": [
      "TULN",
      "Tulane"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#006747",
    "alternateColor": "#418fde",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2655.png",
      "https://cdn.collegefootballdata.com/logos/256/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2655.png",
      "https://cdn.collegefootballdata.com/logos/128/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2655.png",
      "https://cdn.collegefootballdata.com/logos/96/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2655.png",
      "https://cdn.collegefootballdata.com/logos/64/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2655.png",
      "https://cdn.collegefootballdata.com/logos/48/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2655.png",
      "https://cdn.collegefootballdata.com/logos/32/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2655.png",
      "https://cdn.collegefootballdata.com/logos/16/2655.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2655.png"
    ],
    "twitter": "@GreenWaveFB",
    "location": {
      "id": 4729,
      "name": "Yulman Stadium",
      "city": "New Orleans",
      "state": "LA",
      "zip": "70118",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 29.944616,
      "longitude": -90.116692,
      "elevation": "0.0000000000000000000000000000000000000118",
      "capacity": 30000,
      "constructionYear": 2014,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 202,
    "school": "Tulsa",
    "mascot": "Golden Hurricane",
    "abbreviation": "TLSA",
    "alternateNames": [
      "TLSA",
      "Tulsa"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#003595",
    "alternateColor": "#d0b787",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/202.png",
      "https://cdn.collegefootballdata.com/logos/256/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/202.png",
      "https://cdn.collegefootballdata.com/logos/128/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/202.png",
      "https://cdn.collegefootballdata.com/logos/96/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/202.png",
      "https://cdn.collegefootballdata.com/logos/64/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/202.png",
      "https://cdn.collegefootballdata.com/logos/48/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/202.png",
      "https://cdn.collegefootballdata.com/logos/32/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/202.png",
      "https://cdn.collegefootballdata.com/logos/16/202.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/202.png"
    ],
    "twitter": "@TulsaFootball",
    "location": {
      "id": 3674,
      "name": "Chapman Stadium",
      "city": "Tulsa",
      "state": "OK",
      "zip": "74194",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 36.1489175,
      "longitude": -95.9437853,
      "elevation": "235.5928345",
      "capacity": 30000,
      "constructionYear": 1930,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 5,
    "school": "UAB",
    "mascot": "Blazers",
    "abbreviation": "UAB",
    "alternateNames": [
      "Alabama-Birmingham",
      "UAB",
      "UAB"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#1a5632",
    "alternateColor": "#fdb913",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/5.png",
      "https://cdn.collegefootballdata.com/logos/256/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/5.png",
      "https://cdn.collegefootballdata.com/logos/128/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/5.png",
      "https://cdn.collegefootballdata.com/logos/96/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/5.png",
      "https://cdn.collegefootballdata.com/logos/64/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/5.png",
      "https://cdn.collegefootballdata.com/logos/48/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/5.png",
      "https://cdn.collegefootballdata.com/logos/32/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/5.png",
      "https://cdn.collegefootballdata.com/logos/16/5.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/5.png"
    ],
    "twitter": "@UAB_FB",
    "location": {
      "id": 7221,
      "name": "Protective Stadium",
      "city": "Birmingham",
      "state": "AL",
      "zip": "35203",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 33.5206824,
      "longitude": -86.8024326,
      "elevation": "187",
      "capacity": 45000,
      "constructionYear": 2021,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2116,
    "school": "UCF",
    "mascot": "Knights",
    "abbreviation": "UCF",
    "alternateNames": [
      "Central Florida",
      "UCF",
      "UCF"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#b4a169",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2116.png",
      "https://cdn.collegefootballdata.com/logos/256/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2116.png",
      "https://cdn.collegefootballdata.com/logos/128/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2116.png",
      "https://cdn.collegefootballdata.com/logos/96/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2116.png",
      "https://cdn.collegefootballdata.com/logos/64/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2116.png",
      "https://cdn.collegefootballdata.com/logos/48/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2116.png",
      "https://cdn.collegefootballdata.com/logos/32/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2116.png",
      "https://cdn.collegefootballdata.com/logos/16/2116.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2116.png"
    ],
    "twitter": "@UCF_Football",
    "location": {
      "id": 3652,
      "name": "FBC Mortgage Stadium",
      "city": "Orlando",
      "state": "FL",
      "zip": "32816",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 28.6079765,
      "longitude": -81.1927233,
      "elevation": "20.94113731",
      "capacity": 44206,
      "constructionYear": 2007,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 26,
    "school": "UCLA",
    "mascot": "Bruins",
    "abbreviation": "UCLA",
    "alternateNames": [
      "UCLA",
      "UCLA"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#2774ae",
    "alternateColor": "#f2a900",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/26.png",
      "https://cdn.collegefootballdata.com/logos/256/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/26.png",
      "https://cdn.collegefootballdata.com/logos/128/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/26.png",
      "https://cdn.collegefootballdata.com/logos/96/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/26.png",
      "https://cdn.collegefootballdata.com/logos/64/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/26.png",
      "https://cdn.collegefootballdata.com/logos/48/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/26.png",
      "https://cdn.collegefootballdata.com/logos/32/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/26.png",
      "https://cdn.collegefootballdata.com/logos/16/26.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/26.png"
    ],
    "twitter": "@UCLAFootball",
    "location": {
      "id": 1056,
      "name": "Rose Bowl",
      "city": "Pasadena",
      "state": "CA",
      "zip": "90095",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 34.1613284,
      "longitude": -118.1676462,
      "elevation": "245.1772461",
      "capacity": 88565,
      "constructionYear": 1922,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 41,
    "school": "UConn",
    "mascot": "Huskies",
    "abbreviation": "CONN",
    "alternateNames": [
      "Connecticut",
      "CONN",
      "UConn"
    ],
    "conference": "FBS Independents",
    "division": null,
    "classification": "fbs",
    "color": "#000e2f",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/41.png",
      "https://cdn.collegefootballdata.com/logos/256/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/41.png",
      "https://cdn.collegefootballdata.com/logos/128/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/41.png",
      "https://cdn.collegefootballdata.com/logos/96/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/41.png",
      "https://cdn.collegefootballdata.com/logos/64/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/41.png",
      "https://cdn.collegefootballdata.com/logos/48/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/41.png",
      "https://cdn.collegefootballdata.com/logos/32/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/41.png",
      "https://cdn.collegefootballdata.com/logos/16/41.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/41.png"
    ],
    "twitter": "@UConnFootball",
    "location": {
      "id": 3892,
      "name": "Pratt & Whitney Stadium",
      "city": "East Hartford",
      "state": "CT",
      "zip": "6118 ",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 41.7595675,
      "longitude": -72.6187728,
      "elevation": "6.515614986",
      "capacity": 40000,
      "constructionYear": 2003,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 2433,
    "school": "UL Monroe",
    "mascot": "Warhawks",
    "abbreviation": "ULM",
    "alternateNames": [
      "La.-Monroe",
      "ULM",
      "UL Monroe"
    ],
    "conference": "Sun Belt",
    "division": "West",
    "classification": "fbs",
    "color": "#840029",
    "alternateColor": "#fdb913",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2433.png",
      "https://cdn.collegefootballdata.com/logos/256/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2433.png",
      "https://cdn.collegefootballdata.com/logos/128/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2433.png",
      "https://cdn.collegefootballdata.com/logos/96/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2433.png",
      "https://cdn.collegefootballdata.com/logos/64/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2433.png",
      "https://cdn.collegefootballdata.com/logos/48/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2433.png",
      "https://cdn.collegefootballdata.com/logos/32/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2433.png",
      "https://cdn.collegefootballdata.com/logos/16/2433.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2433.png"
    ],
    "twitter": "@ULM_FB",
    "location": {
      "id": 3817,
      "name": "Malone Stadium",
      "city": "Monroe",
      "state": "LA",
      "zip": "71209",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 32.5308089,
      "longitude": -92.0660602,
      "elevation": "22.998209",
      "capacity": 27617,
      "constructionYear": 1978,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2439,
    "school": "UNLV",
    "mascot": "Rebels",
    "abbreviation": "UNLV",
    "alternateNames": [
      "Nevada-Las Vegas",
      "UNLV",
      "UNLV"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#cf0a2c",
    "alternateColor": "#cac8c8",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2439.png",
      "https://cdn.collegefootballdata.com/logos/256/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2439.png",
      "https://cdn.collegefootballdata.com/logos/128/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2439.png",
      "https://cdn.collegefootballdata.com/logos/96/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2439.png",
      "https://cdn.collegefootballdata.com/logos/64/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2439.png",
      "https://cdn.collegefootballdata.com/logos/48/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2439.png",
      "https://cdn.collegefootballdata.com/logos/32/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2439.png",
      "https://cdn.collegefootballdata.com/logos/16/2439.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2439.png"
    ],
    "twitter": "@UNLVFootball",
    "location": {
      "id": 6501,
      "name": "Allegiant Stadium",
      "city": "Las Vegas",
      "state": "NV",
      "zip": "89118",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 36.09075,
      "longitude": -115.183722,
      "elevation": "666",
      "capacity": 65000,
      "constructionYear": 2020,
      "grass": false,
      "dome": true
    }
  },
  {
    "id": 30,
    "school": "USC",
    "mascot": "Trojans",
    "abbreviation": "USC",
    "alternateNames": [
      "USC",
      "USC"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#990000",
    "alternateColor": "#ffcc00",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/30.png",
      "https://cdn.collegefootballdata.com/logos/256/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/30.png",
      "https://cdn.collegefootballdata.com/logos/128/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/30.png",
      "https://cdn.collegefootballdata.com/logos/96/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/30.png",
      "https://cdn.collegefootballdata.com/logos/64/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/30.png",
      "https://cdn.collegefootballdata.com/logos/48/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/30.png",
      "https://cdn.collegefootballdata.com/logos/32/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/30.png",
      "https://cdn.collegefootballdata.com/logos/16/30.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/30.png"
    ],
    "twitter": "@uscfb",
    "location": {
      "id": 477,
      "name": "Los Angeles Memorial Coliseum",
      "city": "Los Angeles",
      "state": "CA",
      "zip": "90089",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 34.014167,
      "longitude": -118.287778,
      "elevation": "42.50374222",
      "capacity": 77500,
      "constructionYear": 1923,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 254,
    "school": "Utah",
    "mascot": "Utes",
    "abbreviation": "UTAH",
    "alternateNames": [
      "UTAH",
      "Utah"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#be0000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/254.png",
      "https://cdn.collegefootballdata.com/logos/256/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/254.png",
      "https://cdn.collegefootballdata.com/logos/128/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/254.png",
      "https://cdn.collegefootballdata.com/logos/96/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/254.png",
      "https://cdn.collegefootballdata.com/logos/64/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/254.png",
      "https://cdn.collegefootballdata.com/logos/48/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/254.png",
      "https://cdn.collegefootballdata.com/logos/32/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/254.png",
      "https://cdn.collegefootballdata.com/logos/16/254.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/254.png"
    ],
    "twitter": "@Utah_Football",
    "location": {
      "id": 587,
      "name": "Rice-Eccles Stadium",
      "city": "Salt Lake City",
      "state": "UT",
      "zip": "84112",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 40.7599724,
      "longitude": -111.8488255,
      "elevation": "1411.543579",
      "capacity": 51444,
      "constructionYear": 1998,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 328,
    "school": "Utah State",
    "mascot": "Aggies",
    "abbreviation": "USU",
    "alternateNames": [
      "USU",
      "Utah State"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#0f2439",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/328.png",
      "https://cdn.collegefootballdata.com/logos/256/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/328.png",
      "https://cdn.collegefootballdata.com/logos/128/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/328.png",
      "https://cdn.collegefootballdata.com/logos/96/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/328.png",
      "https://cdn.collegefootballdata.com/logos/64/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/328.png",
      "https://cdn.collegefootballdata.com/logos/48/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/328.png",
      "https://cdn.collegefootballdata.com/logos/32/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/328.png",
      "https://cdn.collegefootballdata.com/logos/16/328.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/328.png"
    ],
    "twitter": "@USUFootball",
    "location": {
      "id": 3905,
      "name": "Maverik Stadium",
      "city": "Logan",
      "state": "UT",
      "zip": "84322",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 41.7517394,
      "longitude": -111.8116007,
      "elevation": "1427.914429",
      "capacity": 25513,
      "constructionYear": 1968,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2638,
    "school": "UTEP",
    "mascot": "Miners",
    "abbreviation": "UTEP",
    "alternateNames": [
      "Texas-El Paso",
      "UTEP",
      "UTEP"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#ff8200",
    "alternateColor": "#041e42",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2638.png",
      "https://cdn.collegefootballdata.com/logos/256/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2638.png",
      "https://cdn.collegefootballdata.com/logos/128/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2638.png",
      "https://cdn.collegefootballdata.com/logos/96/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2638.png",
      "https://cdn.collegefootballdata.com/logos/64/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2638.png",
      "https://cdn.collegefootballdata.com/logos/48/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2638.png",
      "https://cdn.collegefootballdata.com/logos/32/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2638.png",
      "https://cdn.collegefootballdata.com/logos/16/2638.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2638.png"
    ],
    "twitter": "@UTEPFB",
    "location": {
      "id": 3946,
      "name": "Sun Bowl",
      "city": "El Paso",
      "state": "TX",
      "zip": "79968",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 31.7733353,
      "longitude": -106.507957,
      "elevation": "1183.697876",
      "capacity": 51500,
      "constructionYear": 1963,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2636,
    "school": "UTSA",
    "mascot": "Roadrunners",
    "abbreviation": "UTSA",
    "alternateNames": [
      "Texas-San Antonio",
      "UTSA",
      "UTSA"
    ],
    "conference": "American Athletic",
    "division": null,
    "classification": "fbs",
    "color": "#0c2340",
    "alternateColor": "#f15a22",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2636.png",
      "https://cdn.collegefootballdata.com/logos/256/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2636.png",
      "https://cdn.collegefootballdata.com/logos/128/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2636.png",
      "https://cdn.collegefootballdata.com/logos/96/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2636.png",
      "https://cdn.collegefootballdata.com/logos/64/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2636.png",
      "https://cdn.collegefootballdata.com/logos/48/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2636.png",
      "https://cdn.collegefootballdata.com/logos/32/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2636.png",
      "https://cdn.collegefootballdata.com/logos/16/2636.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2636.png"
    ],
    "twitter": null,
    "location": {
      "id": 3604,
      "name": "Alamodome",
      "city": "San Antonio",
      "state": "TX",
      "zip": "78299",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 29.4169834,
      "longitude": -98.4788143,
      "elevation": "201.5526886",
      "capacity": 36582,
      "constructionYear": 1993,
      "grass": false,
      "dome": true
    }
  },
  {
    "id": 238,
    "school": "Vanderbilt",
    "mascot": "Commodores",
    "abbreviation": "VAN",
    "alternateNames": [
      "VAN",
      "Vanderbilt"
    ],
    "conference": "SEC",
    "division": null,
    "classification": "fbs",
    "color": "#000000",
    "alternateColor": "#cfae70",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/238.png",
      "https://cdn.collegefootballdata.com/logos/256/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/238.png",
      "https://cdn.collegefootballdata.com/logos/128/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/238.png",
      "https://cdn.collegefootballdata.com/logos/96/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/238.png",
      "https://cdn.collegefootballdata.com/logos/64/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/238.png",
      "https://cdn.collegefootballdata.com/logos/48/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/238.png",
      "https://cdn.collegefootballdata.com/logos/32/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/238.png",
      "https://cdn.collegefootballdata.com/logos/16/238.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/238.png"
    ],
    "twitter": "@VandyFootball",
    "location": {
      "id": 3973,
      "name": "FirstBank Stadium",
      "city": "Nashville",
      "state": "TN",
      "zip": "37212",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 36.1440455,
      "longitude": -86.8088942,
      "elevation": "159.9194641",
      "capacity": 40351,
      "constructionYear": 1922,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 258,
    "school": "Virginia",
    "mascot": "Cavaliers",
    "abbreviation": "UVA",
    "alternateNames": [
      "UVA",
      "Virginia"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#232d4b",
    "alternateColor": "#f84c1e",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/258.png",
      "https://cdn.collegefootballdata.com/logos/256/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/258.png",
      "https://cdn.collegefootballdata.com/logos/128/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/258.png",
      "https://cdn.collegefootballdata.com/logos/96/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/258.png",
      "https://cdn.collegefootballdata.com/logos/64/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/258.png",
      "https://cdn.collegefootballdata.com/logos/48/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/258.png",
      "https://cdn.collegefootballdata.com/logos/32/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/258.png",
      "https://cdn.collegefootballdata.com/logos/16/258.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/258.png"
    ],
    "twitter": "@UVAFootball",
    "location": {
      "id": 3923,
      "name": "Scott Stadium",
      "city": "Charlottesville",
      "state": "VA",
      "zip": "22904",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 38.0311801,
      "longitude": -78.5137897,
      "elevation": "170.4677429",
      "capacity": 61500,
      "constructionYear": 1931,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 259,
    "school": "Virginia Tech",
    "mascot": "Hokies",
    "abbreviation": "VT",
    "alternateNames": [
      "VT",
      "Virginia Tech"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#861f41",
    "alternateColor": "#e87722",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/259.png",
      "https://cdn.collegefootballdata.com/logos/256/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/259.png",
      "https://cdn.collegefootballdata.com/logos/128/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/259.png",
      "https://cdn.collegefootballdata.com/logos/96/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/259.png",
      "https://cdn.collegefootballdata.com/logos/64/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/259.png",
      "https://cdn.collegefootballdata.com/logos/48/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/259.png",
      "https://cdn.collegefootballdata.com/logos/32/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/259.png",
      "https://cdn.collegefootballdata.com/logos/16/259.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/259.png"
    ],
    "twitter": "@VT_Football",
    "location": {
      "id": 3799,
      "name": "Lane Stadium",
      "city": "Blacksburg",
      "state": "VA",
      "zip": "24061",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 37.2199873,
      "longitude": -80.4180643,
      "elevation": "632.2631226",
      "capacity": 65632,
      "constructionYear": 1965,
      "grass": true,
      "dome": false
    }
  },
  {
    "id": 154,
    "school": "Wake Forest",
    "mascot": "Demon Deacons",
    "abbreviation": "WAKE",
    "alternateNames": [
      "WAKE",
      "Wake Forest"
    ],
    "conference": "ACC",
    "division": null,
    "classification": "fbs",
    "color": "#ceb888",
    "alternateColor": "#2c2a29",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/154.png",
      "https://cdn.collegefootballdata.com/logos/256/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/154.png",
      "https://cdn.collegefootballdata.com/logos/128/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/154.png",
      "https://cdn.collegefootballdata.com/logos/96/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/154.png",
      "https://cdn.collegefootballdata.com/logos/64/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/154.png",
      "https://cdn.collegefootballdata.com/logos/48/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/154.png",
      "https://cdn.collegefootballdata.com/logos/32/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/154.png",
      "https://cdn.collegefootballdata.com/logos/16/154.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/154.png"
    ],
    "twitter": "@WakeFB",
    "location": {
      "id": 3630,
      "name": "Allegacy Federal Credit Union Stadium",
      "city": "Winston-Salem",
      "state": "NC",
      "zip": "27105",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 36.1305507,
      "longitude": -80.2545851,
      "elevation": "283.548584",
      "capacity": 31500,
      "constructionYear": 1968,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 264,
    "school": "Washington",
    "mascot": "Huskies",
    "abbreviation": "WASH",
    "alternateNames": [
      "WASH",
      "Washington"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#33006f",
    "alternateColor": "#e8d3a2",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/264.png",
      "https://cdn.collegefootballdata.com/logos/256/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/264.png",
      "https://cdn.collegefootballdata.com/logos/128/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/264.png",
      "https://cdn.collegefootballdata.com/logos/96/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/264.png",
      "https://cdn.collegefootballdata.com/logos/64/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/264.png",
      "https://cdn.collegefootballdata.com/logos/48/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/264.png",
      "https://cdn.collegefootballdata.com/logos/32/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/264.png",
      "https://cdn.collegefootballdata.com/logos/16/264.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/264.png"
    ],
    "twitter": "@UW_Football",
    "location": {
      "id": 3765,
      "name": "Husky Stadium",
      "city": "Seattle",
      "state": "WA",
      "zip": "98195",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 47.6503235,
      "longitude": -122.3015746,
      "elevation": "11.65622807",
      "capacity": 70138,
      "constructionYear": 1920,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 265,
    "school": "Washington State",
    "mascot": "Cougars",
    "abbreviation": "WSU",
    "alternateNames": [
      "WSU",
      "Washington St"
    ],
    "conference": "Pac-12",
    "division": null,
    "classification": "fbs",
    "color": "#a60f2d",
    "alternateColor": "#4d4d4d",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/265.png",
      "https://cdn.collegefootballdata.com/logos/256/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/265.png",
      "https://cdn.collegefootballdata.com/logos/128/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/265.png",
      "https://cdn.collegefootballdata.com/logos/96/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/265.png",
      "https://cdn.collegefootballdata.com/logos/64/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/265.png",
      "https://cdn.collegefootballdata.com/logos/48/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/265.png",
      "https://cdn.collegefootballdata.com/logos/32/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/265.png",
      "https://cdn.collegefootballdata.com/logos/16/265.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/265.png"
    ],
    "twitter": "@WSUCougarFB",
    "location": {
      "id": 3820,
      "name": "Gesa Field",
      "city": "Pullman",
      "state": "WA",
      "zip": "99164",
      "countryCode": "US",
      "timezone": "America/Los_Angeles",
      "latitude": 46.731831,
      "longitude": -117.1604991,
      "elevation": "773.9526367",
      "capacity": 32952,
      "constructionYear": 1972,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 98,
    "school": "Western Kentucky",
    "mascot": "Hilltoppers",
    "abbreviation": "WKU",
    "alternateNames": [
      "WKU",
      "Western KY"
    ],
    "conference": "Conference USA",
    "division": null,
    "classification": "fbs",
    "color": "#c60c30",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/98.png",
      "https://cdn.collegefootballdata.com/logos/256/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/98.png",
      "https://cdn.collegefootballdata.com/logos/128/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/98.png",
      "https://cdn.collegefootballdata.com/logos/96/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/98.png",
      "https://cdn.collegefootballdata.com/logos/64/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/98.png",
      "https://cdn.collegefootballdata.com/logos/48/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/98.png",
      "https://cdn.collegefootballdata.com/logos/32/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/98.png",
      "https://cdn.collegefootballdata.com/logos/16/98.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/98.png"
    ],
    "twitter": "@WKUFootball",
    "location": {
      "id": 3796,
      "name": "Houchens Industries-L.T. Smith Stadium",
      "city": "Bowling Green",
      "state": "KY",
      "zip": "42101",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 36.9847901,
      "longitude": -86.4594041,
      "elevation": "154.4346619",
      "capacity": 22113,
      "constructionYear": 1968,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2711,
    "school": "Western Michigan",
    "mascot": "Broncos",
    "abbreviation": "WMU",
    "alternateNames": [
      "WMU",
      "W Michigan"
    ],
    "conference": "Mid-American",
    "division": null,
    "classification": "fbs",
    "color": "#532e1f",
    "alternateColor": "#f1c500",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2711.png",
      "https://cdn.collegefootballdata.com/logos/256/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2711.png",
      "https://cdn.collegefootballdata.com/logos/128/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2711.png",
      "https://cdn.collegefootballdata.com/logos/96/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2711.png",
      "https://cdn.collegefootballdata.com/logos/64/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2711.png",
      "https://cdn.collegefootballdata.com/logos/48/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2711.png",
      "https://cdn.collegefootballdata.com/logos/32/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2711.png",
      "https://cdn.collegefootballdata.com/logos/16/2711.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2711.png"
    ],
    "twitter": "@WMU_Football",
    "location": {
      "id": 3980,
      "name": "Waldo Stadium",
      "city": "Kalamazoo",
      "state": "MI",
      "zip": "49008",
      "countryCode": "US",
      "timezone": "America/Detroit",
      "latitude": 42.2860064,
      "longitude": -85.6007573,
      "elevation": "243.8211212",
      "capacity": 30200,
      "constructionYear": 1939,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 277,
    "school": "West Virginia",
    "mascot": "Mountaineers",
    "abbreviation": "WVU",
    "alternateNames": [
      "WVU",
      "West Virginia"
    ],
    "conference": "Big 12",
    "division": null,
    "classification": "fbs",
    "color": "#eaaa00",
    "alternateColor": "#002855",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/277.png",
      "https://cdn.collegefootballdata.com/logos/256/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/277.png",
      "https://cdn.collegefootballdata.com/logos/128/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/277.png",
      "https://cdn.collegefootballdata.com/logos/96/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/277.png",
      "https://cdn.collegefootballdata.com/logos/64/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/277.png",
      "https://cdn.collegefootballdata.com/logos/48/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/277.png",
      "https://cdn.collegefootballdata.com/logos/32/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/277.png",
      "https://cdn.collegefootballdata.com/logos/16/277.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/277.png"
    ],
    "twitter": "@WVUFootball",
    "location": {
      "id": 3842,
      "name": "Milan Puskar Stadium",
      "city": "Morgantown",
      "state": "WV",
      "zip": "26507",
      "countryCode": "US",
      "timezone": "America/New_York",
      "latitude": 39.6502744,
      "longitude": -79.9551873,
      "elevation": "327.409668",
      "capacity": 60000,
      "constructionYear": 1980,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 275,
    "school": "Wisconsin",
    "mascot": "Badgers",
    "abbreviation": "WIS",
    "alternateNames": [
      "WIS",
      "Wisconsin"
    ],
    "conference": "Big Ten",
    "division": null,
    "classification": "fbs",
    "color": "#a00000",
    "alternateColor": "#ffffff",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/275.png",
      "https://cdn.collegefootballdata.com/logos/256/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/275.png",
      "https://cdn.collegefootballdata.com/logos/128/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/275.png",
      "https://cdn.collegefootballdata.com/logos/96/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/275.png",
      "https://cdn.collegefootballdata.com/logos/64/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/275.png",
      "https://cdn.collegefootballdata.com/logos/48/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/275.png",
      "https://cdn.collegefootballdata.com/logos/32/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/275.png",
      "https://cdn.collegefootballdata.com/logos/16/275.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/275.png"
    ],
    "twitter": "@BadgerFootball",
    "location": {
      "id": 347,
      "name": "Camp Randall Stadium",
      "city": "Madison",
      "state": "WI",
      "zip": "53711",
      "countryCode": "US",
      "timezone": "America/Chicago",
      "latitude": 43.06994,
      "longitude": -89.4126943,
      "elevation": "263.604126",
      "capacity": 80321,
      "constructionYear": 1917,
      "grass": false,
      "dome": false
    }
  },
  {
    "id": 2751,
    "school": "Wyoming",
    "mascot": "Cowboys",
    "abbreviation": "WYO",
    "alternateNames": [
      "WYO",
      "Wyoming"
    ],
    "conference": "Mountain West",
    "division": null,
    "classification": "fbs",
    "color": "#492f24",
    "alternateColor": "#ffc425",
    "logos": [
      "https://cdn.collegefootballdata.com/logos/500/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/500/2751.png",
      "https://cdn.collegefootballdata.com/logos/256/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/256/2751.png",
      "https://cdn.collegefootballdata.com/logos/128/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/128/2751.png",
      "https://cdn.collegefootballdata.com/logos/96/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/96/2751.png",
      "https://cdn.collegefootballdata.com/logos/64/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/64/2751.png",
      "https://cdn.collegefootballdata.com/logos/48/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/48/2751.png",
      "https://cdn.collegefootballdata.com/logos/32/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/32/2751.png",
      "https://cdn.collegefootballdata.com/logos/16/2751.png",
      "https://cdn.collegefootballdata.com/logos-dark/16/2751.png"
    ],
    "twitter": "@Wyo_Football",
    "location": {
      "id": 3984,
      "name": "War Memorial Stadium",
      "city": "Laramie",
      "state": "WY",
      "zip": "82071",
      "countryCode": "US",
      "timezone": "America/Denver",
      "latitude": 41.31161,
      "longitude": -105.5681384,
      "elevation": "2200.153564",
      "capacity": 29181,
      "constructionYear": 1950,
      "grass": false,
      "dome": false
    }
  }
]